import { CostCenterUIModel } from "@/Administration/Models/UI/CostCenterUIModel";
import { AdministrationStore } from "@/Administration/Stores/AdministrationStore";
import { AIScribeLinkedUserModel } from "@/AIScribe/Models/AIScribeLinkedUserModel";
import { AIScribeStore } from "@/AIScribe/Stores/AIScribeStore";
import { PAListDisplaySettings } from "@/Appointments/Models/Settings/PAListDisplaySettings";
import { CalendarStore } from "@/Appointments/Stores/CalendarStore";
import { SchedulingStore } from "@/Appointments/Stores/SchedulingStore";
import { BillingStore } from "@/Billing/Stores/BillingStore";
import { Client } from "@/Common/Api/Client";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { EmployeeGroup } from "@/Common/Api/Employee/Dto/EmployeeGroup";
import { EmployeeTermsAndConditionsAgreement } from "@/Common/Api/Employee/Dto/EmployeeTermsAndConditionsAgreement";
import { License } from "@/Common/Api/Employee/Dto/License";
import { Permission as MyleModelsCommonResponsePermission } from "@/Common/Api/Employee/Dto/Permission";
import { ServiceTermsAndConditionsDictionary } from "@/Common/Api/Employee/Dto/ServiceTermsAndConditionsDictionary";
import { ClinicSettings } from "@/Common/Api/MedfarDictionaries/Dto/Responses/ClinicSettings";
import { ClinicSettings_Portal } from "@/Common/Api/MedfarDictionaries/Dto/Responses/ClinicSettings_Portal";
import { ClinicSettingsSingleSignOnProvider } from "@/Common/Api/MedfarDictionaries/Dto/Responses/ClinicSettings_SingleSignOn";
import { DefaultCanadaTaxes } from "@/Common/Api/MedfarDictionaries/Dto/Responses/DefaultCanadaTaxes";
import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { FlatLookupViewLight } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupViewLight";
import { Frequency } from "@/Common/Api/MedfarDictionaries/Dto/Responses/Frequencies";
import { Geo_Region } from "@/Common/Api/MedfarDictionaries/Dto/Responses/Geo_Region";
import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { LicenceOrganisationSpecialisation } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationSpecialisation";
import { MedfarDictionariesValidationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/MedfarDictionariesValidationRule";
import { PublicServiceEndpoints } from "@/Common/Api/MedfarDictionaries/Dto/Responses/PublicServiceEndpoints";
import { Route } from "@/Common/Api/MedfarDictionaries/Dto/Responses/Routes";
import { SearchSpecialityResult } from "@/Common/Api/MedfarDictionaries/Dto/Responses/SearchSpecialityResult";
import { Unit } from "@/Common/Api/MedfarDictionaries/Dto/Responses/Unit";
import { Vaccine } from "@/Common/Api/MedfarDictionaries/Dto/Responses/Vaccines";
import { ToggleFavoriteResponse } from "@/Common/Api/Medication/Dto/ToggleFavoriteResponse";
import { PatientExternalIdentifierIndexesResponse } from "@/Common/Api/Patient/Dto/PatientExternalIdentifierIndexes/PatientExternalIdentifierIndexesResponse";
import { PatientExternalIdentifierIndexesSitesResponse } from "@/Common/Api/Patient/Dto/PatientExternalIdentifierIndexes/PatientExternalIdentifierIndexesSitesResponse";
import { ExternalSearchSystem } from "@/Common/Api/PatientExternalSearch/Dto/ExternalSearchSystem";
import { ExternalSearchSystemResponse } from "@/Common/Api/PatientExternalSearch/Dto/ExternalSearchSystemResponse";
import { ExternalSearchSystemSiteResponse } from "@/Common/Api/PatientExternalSearch/Dto/ExternalSearchSystemSiteResponse";
import { PreventiveCareCriteria } from "@/Common/Api/PreventiveCare/Dto/Responses/PreventiveCareCriteria";
import { RadPdfFormResponse } from "@/Common/Api/RadPdf/RadPdfFormResponse";
import { ScreeningTestDefinition } from "@/Common/Api/Screening/Dto/Responses/ScreeningTestDefinition";
import { ScreeningTestProfile } from "@/Common/Api/Screening/Dto/Responses/ScreeningTestProfile";
import { ScreeningTestProfileDefinition } from "@/Common/Api/Screening/Dto/Responses/ScreeningTestProfileDefinition";
import { NotificationConfigurationCompositeDto } from "@/Common/Api/Services/Dto/NotificationConfigurationDto";
import { Service as MyleModelsCommonResponseService } from "@/Common/Api/Services/Dto/Responses/Service";
import { ServiceComboDefinition, ServiceDefinition } from "@/Common/Api/Services/Dto/Responses/ServiceDefinition";
import { ServiceDefinitionDTO } from "@/Common/Api/Services/Dto/ServiceDefinitionDTO";
import { SpecificClientSettings } from "@/Common/Api/Settings/Dto/Responses/SpecificClientSettings";
import { DropDownOptionResponse } from "@/Common/Api/UI/Dto/DropDownOptionResponse";
import { ValidationRule } from "@/Common/Api/Validation/Dto/Responses/ValidationRule";
import { PrivateBillCostCenter } from "@/Common/Components/Billing/PrivateBillCostCenter";
import { DateTime } from "@/Common/Helpers/DateTime";
import { EmployeeTitleHelper } from "@/Common/Helpers/EmployeeTitleHelper";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";
import { WalkmeHelper } from "@/Common/Helpers/WalkmeHelper";
import { IAllowlistModel } from "@/Common/Models/Administration/IAllowlistModel";
import { ApplicationStrings } from "@/Common/Models/ApplicationStrings";
import { DatabaseLocation } from "@/Common/Models/ArlMyle/DatabaseLocation";
import { Address } from "@/Common/Models/Contacts/Address";
import { ContactPointType } from "@/Common/Models/Contacts/Enums/ContactPointType";
import { PhoneType } from "@/Common/Models/Contacts/Enums/PhoneType";
import { EmployeeTitle } from "@/Common/Models/Employee/Enums/EmployeeTitle";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { EnumMyleLoginPermission } from "@/Common/Models/EnumMyleLoginPermission";
import { EnumSentFaxStatus } from "@/Common/Models/Faxing/EnumSentFaxStatus";
import { FaxAccount } from "@/Common/Models/Faxing/FaxAccount";
import { Guid } from "@/Common/Models/Guid";
import { LISRISCode } from "@/Common/Models/LISRISCode";
import { GeographicInfoCountry } from "@/Common/Models/Localization/GeographicInfoCountry";
import { GeographicInfoState } from "@/Common/Models/Localization/GeographicInfoState";
import { GeographicInfoTown } from "@/Common/Models/Localization/GeographicInfoTowns";
import { Locale } from "@/Common/Models/Localization/Locale";
import { LookupDictionary } from "@/Common/Models/LookupDictionary";
import { TitleAndSpecialtyModel } from "@/Common/Models/MedfarDictionaries/TitleAndSpecialtyModel";
import { MyleTabKey } from "@/Common/Models/MyleMenu/enums/MyleTabKey";
import { MyleMenuTabItem } from "@/Common/Models/MyleMenu/MyleMenuTabItem";
import { DocumentsCounters } from "@/Common/Models/MyleMenu/Tooltip/DocumentsCounter";
import { ICounters } from "@/Common/Models/MyleMenu/Tooltip/ICounters";
import { MyleMenuTabTooltip } from "@/Common/Models/MyleMenu/Tooltip/MyleMenuTabTooltip";
import { Gender } from "@/Common/Models/Patient/PatientEnums";
import { ReligionData } from "@/Common/Models/Patient/UI/Profile/ReligionModel";
import { Person } from "@/Common/Models/Person/Person";
import { PortalConfigurationDto } from "@/Common/Models/Portal/ClinicConfig/PortalConfigurationDto";
import { SubscriptionPlanDto } from "@/Common/Models/Portal/ClinicConfig/SubscriptionPlanDto";
import { SharedItemCategory } from "@/Common/Models/Portal/SharedItem/SharedItemCategory";
import { QuestionnaireName } from "@/Common/Models/Questionnaires/QuestionnaireName";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { ServiceComboDefinitionModel } from "@/Common/Models/Services/ServiceComboDefinitionModel";
import { ServiceDefinitionModel, ServiceDefinitionModelEmployee } from "@/Common/Models/Services/ServiceDefinitionModel";
import { ServiceModel } from "@/Common/Models/Services/ServiceModel";
import { Site } from "@/Common/Models/Sites/ResponseModels/Site";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import { SiteUIModel } from "@/Common/Models/Sites/SiteUIModel";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { CheckboxUIModel } from "@/Common/Models/UI/Inputs/CheckboxUIModel";
import { DropDownOption } from "@/Common/Models/UI/Inputs/DropDownOption";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import { SentFaxUiStatus } from "@/Common/Models/UI/SentFaxUiStatus";
import * as ServerOperations from "@/Common/Operations/operations.server";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { CanadaState, CountryNames, DiscontinueReason, ExternalBillingPaymentMode } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { CacheAction } from "@/Common/Stores/Actions/CacheAction";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { LoginAction } from "@/Common/Stores/Actions/LoginAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { GlobalRequestMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { RamqStore } from "@/Common/Stores/RamqStore";
import { SidebarStore } from "@/Common/Stores/SidebarStore";
import { IFilteredOrganizationRulesParams } from "@/Common/Utilities/FilteredOrganizationRules";
import { LocationMapper } from "@/Common/Utilities/LocationMapper";
import { TempLightVacation } from "@/Communications/Models/TempLightVacation";
import { CommunicationsStore } from "@/Communications/Stores/CommunicationsStore";
import { GlobalSendCommunicationStore } from "@/Communications/Stores/GlobalSendCommunicationStore";
import { IDocumentsTabModel } from "@/Documents/Models/UI/IDocumentsTabModel";
import { DocumentsStore } from "@/Documents/Stores/DocumentsStore";
import { Cache, ClinicSettingsCache } from "@/Globals/Models/Cache";
import { UserSettings } from "@/Globals/Models/UserSettings";
import { ILabsGlobalWrapper } from "@/Labs/Models/UI/ILabsGlobalWrapper";
import { LabsStore } from "@/Labs/Stores/LabsStore";
import { ListsStore } from "@/Lists/Stores/ListsStore";
import { GetFavoritePrescriptionResponse } from "@/Patient/Api/Dto/Responses/GetFavoritePrescriptionResponse";
import { InsuranceProvider } from "@/Patient/Api/Dto/Responses/InsuranceProvider";
import { SharedItemCategoryResponse } from "@/Patient/Api/Dto/Responses/SharedItemCategoryResponse";
import { PatientMedicalSummaryHelper } from "@/Patient/Helpers/PatientMedicalSummaryHelper";
import { FavoriteForm } from "@/Patient/Models/Forms/FavoriteForms";
import { GenericForm } from "@/Patient/Models/Forms/GenericForm";
import { RadPdfFormData } from "@/Patient/Models/Forms/RadPdf/RadPdfFormData";
import { GrowthChartsCacheData } from "@/Patient/Models/GrowthCharts/GrowthChartsCacheData";
import { DiagnosisModel } from "@/Patient/Models/MedicalSummary/DiagnosisModel";
import { FavoriteDiagnosisComposite } from "@/Patient/Models/MedicalSummary/FavoriteDiagnosisComposite";
import { MedicalItemMedicationAndPrescription } from "@/Patient/Models/MedicalSummary/MedicalItemMedicationAndPrescription";
import { RiskFactorCategoryCode, RiskFactorCode } from "@/Patient/Models/MedicalSummary/RiskFactorCode";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";
import { PatientStore } from "@/Patient/Stores/PatientStore";
import { PharmacyOrdersStore } from "@/PharmacyOrders/Stores/PharmacyOrdersStore";
import { PortfolioStore } from "@/Portfolio/Stores/PortfolioStore";
import { PrescriptionRenewalsStore } from "@/PrescriptionRenewals/Stores/PrescriptionRenewalsStore";
import { ReportingStore } from "@/Report/Stores/ReportingStore";
import { SettingsStore } from "@/Settings/Stores/SettingsStore";
import { CacheHandler } from "./Handlers/Local/CacheHandler";
import { PhoneUtils } from "./utils/PhoneNumberHelper";
import { SessionStore } from "./SessionStore";

let defaultInstance: CacheStore;

class CacheStore extends BaseStore {
    private ResourceStrings: { [locale in Locale]?: ApplicationStrings } = {};
    private LookupStrings: { [locale in Locale]?: ApplicationStrings } = {};
    private LoadingLocales: { [locale in Locale]?: (() => void)[] } = {};

    private EmployeeCacheWithInactiveByContactFacetId: { [contactFacetId: string]: Employee } = {};

    private Lookups: FlatLookupView[];
    private LookupsDict: { [lookupId: string]: FlatLookupView };
    private LookupsByLookupCodeCacheDict: { [lookupTypeCode: string]: FlatLookupView[] };
    private LookupsByTypeCodeCacheDict: { [lookupCode: string]: FlatLookupView[] };
    private LookupsByTypeNameCacheDict: { [typeName: string]: FlatLookupView[] };

    private InsuranceProviderCache: InsuranceProvider[];
    private mapper: GlobalRequestMapper;
    private requestHandler: CacheHandler;

    private ExternalSearchSystemsBySiteId: { [SiteId: string]: ExternalSearchSystem[] };

    public PatientExternalIdentifierIndexes: PatientExternalIdentifierIndexesResponse[];
    public PatientExternalIdentifierIndexesSites: PatientExternalIdentifierIndexesSitesResponse[];
    public PatientExternalIdentifierIndexesBySystemCode: { [SystemCode: string]: PatientExternalIdentifierIndexesResponse[] };
    public PatientExternalIdentifierIndexesSitesBySystemCode: { [SystemCode: string]: PatientExternalIdentifierIndexesSitesResponse[] };

    private PDFFormsList: RadPdfFormData[];

    private DropDownOptions: DropDownOptionResponse[];
    private DropDownOptionsByTypCacheDict: LookupDictionary<DropDownOption>;

    private screeningTestDefinitions: ScreeningTestDefinition[];
    private screeningTestProfileDefinitions: ScreeningTestProfileDefinition[];

    private timeoutReferenceCacheChange: number;
    private cacheChangeTimeStamp: Date;

    private memoizeRelationshipTupleFemale: [FlatLookupView, FlatLookupView][];
    private memoizeRelationshipTupleMale: [FlatLookupView, FlatLookupView][];

    private memorizedMDFamille_LORSpecialityId: string[];

    private memorizedMDFamilleResident_LORSpecialityId: string[];
    private employeeTermsAndConditionsAgreement: EmployeeTermsAndConditionsAgreement[];
    private sharedItemCategories: SharedItemCategory[];

    public ApexInterfaceCode: string = "A";

    public Tabs: MyleMenuTabItem[];
    public Helper: MyleHelper;

    /**
     * The raw employee data. Use this.Clinicians for typed data.
     */
    public EmployeeCache: Employee[];

    /**
     * The raw employee data. Use this.Clinicians for typed data.
     */
    public EmployeeCacheWithInactive: Employee[];

    public EmployeeGroupCache: EmployeeGroup[];
    public ServicesByEmployees: { [employeeContactFacetId: string]: MyleModelsCommonResponseService[] };

    public ClinicSettings: ClinicSettings;
    public ClinicSettingsSingleSignOnProviders: ClinicSettingsSingleSignOnProvider[];
    public ClinicSettings_Portal: ClinicSettings_Portal;
    public NotificationConfiguration: NotificationConfigurationCompositeDto;
    public SpecificClientSettings: SpecificClientSettings;

    public ServiceDefinitionCache: Immutable.List<ServiceDefinitionModel>;
    public ServiceDefinitionComboCache: Immutable.List<ServiceComboDefinitionModel>;
    public AvailableQuestionnaires: QuestionnaireName[];

    public ParentSiteCache: SitesModel[];
    public SiteCache: SitesModel[];

    public RiskFactorCodeCache: Partial<Record<RiskFactorCategoryCode, RiskFactorCode[]>> = {};
    public RiskFactorCodeByIdCache: Record<string, RiskFactorCode> = {};

    public TitlesAndSpecialtiesCache: Immutable.List<SearchableItemModelT<TitleAndSpecialtyModel>>;

    /**
     * The license organization specializations linked to license organization rules.
     */
    public LicenseOrganizationSpecializationsById: { [id: string]: LicenceOrganisationSpecialisation } = {};

    /**
     * The license organization rules linked to specializations.
     */
    public LicenceOrganisationRulesById: { [id: string]: LicenceOrganisationRule } = {};

    /**
     * All license organization rules supported by Myle.
     */
    public AllLicenseOrganizationRulesById: { [id: string]: LicenceOrganisationRule } = {};

    /**
     * IDs of all license organization rules related to doctors in the CMQ organization.
     */
    public CmqDoctorLicenseOrganizationRuleIds: string[] = [];

    public RegionsCache: Geo_Region[];
    public TownsCache: GeographicInfoTown[];

    public HasFRLookups: boolean;
    public HasESLookups: boolean;

    public LISRISCodeDictionary: LISRISCode[];
    public DocumentSources: string[];
    public UserSettings: UserSettings;
    public Clinicians: Person[];
    public CliniciansWithInactive: Person[];
    public SentForApprovalCliniciansId: string[];
    public CliniciansAndEmployeeGroups: Person[];
    public ValidationRules: ValidationRule[];
    public MedfarDictionariesValidationRules: MedfarDictionariesValidationRule[];
    public UnitsCache: Unit[];
    public RoutesCache: Route[];
    public VaccinesCache: Vaccine[];
    public FrequenciesCache: Frequency[];
    public ReligionCache: ReligionData[];
    public FavoritePrescriptions: Immutable.List<MedicationModel>;
    public FavoriteDiagnoses: Immutable.List<DiagnosisModel>;
    public CountryCache: GeographicInfoCountry[];
    public CountryCacheById: { [id: string]: GeographicInfoCountry };
    public StateCache: GeographicInfoState[];
    public StateCacheById: { [id: string]: GeographicInfoState };
    public LocationMapper: LocationMapper;
    public DocumentsState: IDocumentsTabModel;
    public LabsCachedState: ILabsGlobalWrapper;
    public SessionLengthMinutes: number;
    public actions: CacheAction;
    public CurrentUserDefaultSpecializationLookupId: string;

    public RADPdfFormEditUrl: string;
    public RADPdfFormViewUrl: string;
    public radPdfTagsCache: Immutable.List<KeyValuePair<number, string>> = [].toImmutable();

    public ClientIdentifier: string;
    public BatchScanFileMaximum: number;
    public Permissions: MyleModelsCommonResponsePermission[];
    public validationHelper: ValidationHelper;
    public employersCache: Immutable.List<SearchableItemModelT<string>>;
    public CostCenterCache: PrivateBillCostCenter[];
    public ExternalSearchSystemsResponse: ExternalSearchSystemResponse[];
    public ExternalSearchSystemSitesResponse: ExternalSearchSystemSiteResponse[];
    public SitesAddressCache: Address[];
    public ClinicSettingsServices: PublicServiceEndpoints;
    public SafirApssURL: string;
    public FavoriteForms: FavoriteForm[];
    public defaultCurrencyUnit = "CAD";
    public ArlMyleDatabaseLocation: DatabaseLocation;

    public EmployeeSharingMessages: string[];
    public EmployeeSharingTasks: string[];
    public EmployeeSharingExternalCommunications: string[];
    public EmployeeSharingPortalCommunication: string[];
    public serviceTermsAndConditionsDictionary: ServiceTermsAndConditionsDictionary;

    public screeningTestProfiles: ScreeningTestProfile[];
    public PreventiveCareCriteriaList: PreventiveCareCriteria[] = [];

    public CanadianTriageAndAcuityScoreList: number[];

    // portal settings
    public portalConfiguration: PortalConfigurationDto;

    public defaultCanadaTaxes: DefaultCanadaTaxes[];

    public GrowthChartDataModels: GrowthChartsCacheData;

    public faxAccounts: FaxAccount[] = [];

    constructor() {
        super();
        this.LabsCachedState = null;
        this.DocumentsState = null;
        this.Tabs = [];
        this.Helper = new MyleHelper();

        this.mapper = new GlobalRequestMapper();
        this.actions = new CacheAction();
        this.requestHandler = new CacheHandler();
        this.mapper.AddInstance(this.requestHandler);
        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => this.mapper.Map(request));

        this.ServerDispatchToken = ServerResponseDispatcher.register((response: ServerEvent) => {
            switch (response.Operation) {
                case ServerOperations.Server.Myle_LoadUserSettings:
                    let settings = response.Data;
                    this.UserSettings = settings;
                    break;

                case ServerOperations.Server.MedfarDictionnary_SearchSpecialisation:
                    let specialisationResponse: SearchSpecialityResult[] = response.Data.SearchSpecialisationDTOs;
                    if (specialisationResponse != null) {
                        this.LicenceOrganisationRulesById = {};
                        this.LicenseOrganizationSpecializationsById = {};

                        for (const response of specialisationResponse) {
                            this.LicenceOrganisationRulesById[response.licenceOrganisationRule.Id] ??= response.licenceOrganisationRule;
                            this.LicenseOrganizationSpecializationsById[response.licenceOrganisationSpecialisation.Id] ??= new LicenceOrganisationSpecialisation(response.licenceOrganisationSpecialisation);
                        }

                        this.TitlesAndSpecialtiesCache = specialisationResponse
                            .map(x => {
                                let specModel = new TitleAndSpecialtyModel(x.licenceOrganisationRule, x.licenceOrganisationSpecialisation);
                                return new SearchableItemModelT<TitleAndSpecialtyModel>(TitleAndSpecialtyModel.getName(specModel, true), specModel.id, specModel, TitleAndSpecialtyModel.getNameFromAnyLanguage(specModel, true));
                            })
                            .toImmutable();
                    }
                    this.EmitChangeToListeners();
                    break;

                case ServerOperations.Server.MedfarDictionnary_LoadClinicSetting:
                    const data = (response.Data as ClinicSettingsCache);
                    this.ClinicSettings = new ClinicSettings(data.ClinicSettings);
                    this.ClinicSettingsSingleSignOnProviders = data.ClinicSettingsSingleSignOnProviderResponses;
                    sessionStore.ClinicActiveProvinces = data.ClinicActiveProvinces;
                    sessionStorage.setItem("ClinicActiveProvinces", JSON.stringify(data.ClinicActiveProvinces));
                    sessionStore.EmitChangeToListeners();

                    this.EmitChangeToListeners();
                    break;

                case ServerOperations.Server.Myle_LoadCache:
                    this.BindCache(response.Data);
                    window.setTimeout(() => window.document.title = sessionStore.getCurrentEmployee().nameWithPrefix().trim().replace(/ +/g, " "), 100);

                    // init walkMe
                    WalkmeHelper.initializeWalkme();

                    // init stores
                    window.globalSendCommunicationStore = GlobalSendCommunicationStore.createSingleton();
                    window.documentsStore = DocumentsStore.createSingleton();
                    window.calendarStore = CalendarStore.createSingleton();
                    window.ramqStore = RamqStore.createSingleton();
                    window.communicationsStore = CommunicationsStore.createSingleton();
                    window.settingsStore = SettingsStore.createSingleton();
                    window.labsStore = LabsStore.createSingleton();
                    window.administrationStore = AdministrationStore.createSingleton();
                    window.schedulingStore = SchedulingStore.createSingleton();
                    window.sidebarStore = SidebarStore.createSingleton();
                    window.reportingStore = ReportingStore.createSingleton();
                    window.portfolioStore = PortfolioStore.createSingleton();
                    window.billingStore = BillingStore.createSingleton();
                    window.listsStore = ListsStore.createSingleton();
                    window.patientStore = PatientStore.createSingleton();
                    window.prescriptionRenewalsStore = PrescriptionRenewalsStore.createSingleton();
                    window.pharmacyOrdersStore = PharmacyOrdersStore.createSingleton();
                    window.aiScribeStore = AIScribeStore.createSingleton(AIScribeLinkedUserModel.fromDto(response.Data.AIScribeLinkedUser));

                    // init Kendo
                    if (sessionStore.userLanguageCode == "fr")
                        kendo.culture("fr-CA");
                    if (sessionStore.userLanguageCode == "es-MX")
                        kendo.culture("es-MX");

                    // init tabs
                    this.Tabs = CacheStore.InitializeTabs(sessionStore);

                    this.EmitChangeToListeners();

                    sessionStore.clientLoginModel = sessionStore.clientLoginModel.set("IsCacheLoaded", true);
                    this.validationHelper = new ValidationHelper();
                    break;

                case ServerOperations.Server.Myle_AdministrationGetEmployees:
                    this.RefreshEmployees(response);
                    this.actions.refreshLookups();
                    break;

                case ServerOperations.Server.Myle_GetLookups:
                    if (response.SubOperation == SubServerOperations.Administration.RefreshServicesAndLookups) {
                        this.RefreshLookups(response);
                        this.actions.refreshServices();
                    }
                    else
                        this.RefreshLookups(response);
                    break;

                case ServerOperations.Server.Myle_GetFavoritePrescription:
                    this.reloadFavoritePrescription(response.Data);
                    break;
            }
        });
    }

    public static createSingleton(): CacheStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new CacheStore());
    }

    public static createSingletonFrom(store: CacheStore, copy: boolean = true): CacheStore {
        return copy
            ? Object.assign(this.createSingleton(), store)
            : this.createStoreSingleton(defaultInstance, () => defaultInstance = store);
    }

    public static InitializeTabs(sessionStore: SessionStore): MyleMenuTabItem[] {
        return [
            new MyleMenuTabItem({
                key: MyleTabKey.Myle,
                path: "myle",
                permissions: []
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.Admin,
                path: "administration",
                permissions: [EnumMyleLoginPermission.AdminTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.Calendar,
                path: "calendar",
                permissions: [EnumMyleLoginPermission.CalendarTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.Patients,
                path: "patients",
                isLocked: true,
                permissions: [EnumMyleLoginPermission.PatientTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.Communications,
                path: "communications_optimizedv2",
                showCounts: true,
                permissions: [EnumMyleLoginPermission.CommunicationsTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.Documents,
                path: "documents",
                showCounts: true,
                permissions: [EnumMyleLoginPermission.DocumentTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.PrescriptionRenewals,
                path: "prescriptionrenewals",
                showCounts: true,
                permissions: [EnumMyleLoginPermission.PrescriptionRenewalTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.PharmacyOrders,
                path: "orders",
                permissions: [EnumMyleLoginPermission.OrdersTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.Billing,
                path: "billing",
                permissions: cacheStore.ClinicSettings.EnableBillingReconciliationReport
                    ? [EnumMyleLoginPermission.BillingTabPermission, EnumMyleLoginPermission.BillingTabPermissionCurrentUserOnly, EnumMyleLoginPermission.PrivateBillingPermission, EnumMyleLoginPermission.PublicBillingPermission]
                    : [EnumMyleLoginPermission.BillingTabPermission, EnumMyleLoginPermission.BillingTabPermissionCurrentUserOnly]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.Scheduling,
                path: "scheduling",
                permissions: [EnumMyleLoginPermission.AffectationTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.LabResults,
                path: "results",
                permissions: [EnumMyleLoginPermission.LabsTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.Lists,
                path: "lists",
                permissions: [EnumMyleLoginPermission.ListsTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.Portfolio,
                path: "portfolio",
                permissions: [EnumMyleLoginPermission.PortfolioTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.Reporting,
                path: "reporting",
                permissions: [EnumMyleLoginPermission.ReportingTabPermission]
            }),
            new MyleMenuTabItem({
                key: MyleTabKey.Settings,
                path: "settings",
                permissions: [EnumMyleLoginPermission.SettingsTabPermission]
            })
        ]
            .filter(tab => !tab.permissions.length || tab.permissions.some(p => sessionStore.hasPermission(p)));
    }

    /**
     * Get the page size options to use for most paginated lists.
     */
    public getDefaultPageSizes(): number[] {
        return [50, 100, 150];
    }

    /**
     * Get the initial page size for most paginated lists.
     */
    public getDefaultPageSize(): number {
        return 100;
    }

    public RefreshLookups(response: ServerEvent): void {
        let responseLookups = response.Data;
        this.BindLookups(responseLookups.FlatLookupViewLight);
        this.EmitChangeToListeners();
    }

    public RefreshEmployees(response: ServerEvent): void {
        if (response.SubOperation == 0) {
            let responseEmployees = response.Data;
            this.RefreshEmployeesRaw(responseEmployees);
        }
    }

    public RefreshEmployeesRaw(responseEmployees: any): void {
        this.BindEmployeesAndServices(responseEmployees.ServiceDefinitionCache, responseEmployees.EmployeeCache, responseEmployees.ServiceDefinitionComboCache);
        this.EmitChangeToListeners();
    }

    public refreshSites(responseSites: { SiteCache: Site[] }): void {
        this.bindSites(responseSites.SiteCache);
        this.EmitChangeToListeners();
    }

    public refreshFavoriteDiagnoses(): void {
        this.bindFavoriteDiagnoses();
        this.EmitChangeToListeners();
    }

    public BindLookups(lookupCache: FlatLookupViewLight[]): void {
        this.Lookups = lookupCache
            .map(lookup => {
                let result = new FlatLookupView();
                result.LookupID = lookup.LKID;
                result.LookupTypeCode = lookup.LKTypeCode;
                result.LookupCode = lookup.LKCode;
                result.LookupTypeName = lookup.LKTypeName;
                result.en = lookup.en;
                result.fr = lookup.fr;
                result.esMX = lookup.esMX;
                result.LookupPosition = lookup.LKPos;
                this.LookupsDict[result.LookupID] = result;
                return result;
            });
    }

    public rebindLookup(flatLookup: FlatLookupView): void {
        // update lookup dictionary
        this.LookupsDict[flatLookup.LookupID] = flatLookup;

        // update global cache
        {
            let foundLookup = this.Lookups
                .firstOrDefault(x => x.LookupID == flatLookup.LookupID);

            if (foundLookup != null) {
                let foundIdx = this.Lookups.indexOf(foundLookup);
                this.Lookups[foundIdx] = flatLookup;
            }
            else
                this.Lookups.push(flatLookup);
        }

        // update lookup by code cache
        if (this.LookupsByLookupCodeCacheDict[flatLookup.LookupCode] != null) {
            let lookupsFromLookupCodeCache = this.LookupsByLookupCodeCacheDict[flatLookup.LookupCode];
            let foundLookup = lookupsFromLookupCodeCache
                .firstOrDefault(x => x.LookupID == flatLookup.LookupID);

            if (foundLookup != null) {
                let foundIdx = lookupsFromLookupCodeCache.indexOf(foundLookup);
                lookupsFromLookupCodeCache[foundIdx] = flatLookup;
            }
            else
                lookupsFromLookupCodeCache.push(flatLookup);
        }

        // update lookup by type cache
        if (this.LookupsByTypeCodeCacheDict[flatLookup.LookupTypeCode] != null) {
            let lookupsFromTypeCodeCache = this.LookupsByTypeCodeCacheDict[flatLookup.LookupCode];
            let foundLookup = lookupsFromTypeCodeCache
                .firstOrDefault(x => x.LookupID == flatLookup.LookupID);

            if (foundLookup != null) {
                let foundIdx = lookupsFromTypeCodeCache.indexOf(foundLookup);
                lookupsFromTypeCodeCache[foundIdx] = flatLookup;
            }
            else
                lookupsFromTypeCodeCache.push(flatLookup);
        }

        // update lookup by type name cache
        if (this.LookupsByTypeNameCacheDict[flatLookup.LookupTypeName] != null) {
            let lookupsFromTypeNameCache = this.LookupsByTypeCodeCacheDict[flatLookup.LookupCode];
            let foundLookup = lookupsFromTypeNameCache
                .firstOrDefault(x => x.LookupID == flatLookup.LookupID);

            if (foundLookup != null) {
                let foundIdx = lookupsFromTypeNameCache.indexOf(foundLookup);
                lookupsFromTypeNameCache[foundIdx] = flatLookup;
            }
            else
                lookupsFromTypeNameCache.push(flatLookup);
        }
    }

    public RebindSingleEmployeeToCache(employee: Employee): void {
        // clear current employe <-> service link , prep the employee and recreate <-> service link
        this.clearEmployeeFromServiceCache(employee, this.ServiceDefinitionCache.toArray());
        let preparedEmployee = this.prepareEmployeeForCache(employee, this.ServiceDefinitionCache.toArray(), true);

        let idxCache = this.EmployeeCache.indexOfObject("ContactFacet_id", employee.ContactFacet_id);
        if (idxCache > -1 && !employee.IsInactive)
            this.EmployeeCache[idxCache] = preparedEmployee;
        else if (idxCache > -1 && employee.IsInactive)
            this.EmployeeCache.splice(idxCache, 1);
        else
            this.EmployeeCache.push(preparedEmployee);

        let idxCacheInactive = this.EmployeeCacheWithInactive.indexOfObject("ContactFacet_id", employee.ContactFacet_id);
        if (idxCacheInactive > -1)
            this.EmployeeCacheWithInactive[idxCacheInactive] = preparedEmployee;
        else
            this.EmployeeCacheWithInactive.push(preparedEmployee);

        this.EmployeeCacheWithInactiveByContactFacetId = this.EmployeeCacheWithInactive.toDictionary(p => p.ContactFacet_id.toLocaleLowerCase());

        this.refreshClinicianArrays();
    }

    public BindEmployeesAndServices(serviceDefinitionCache: ServiceDefinition[], employeeCache: Employee[], serviceDefinitionComboCache: ServiceComboDefinition[]): void {
        let serviceDefinitionModelCache = serviceDefinitionCache.map(serviceDef => new ServiceDefinitionModel(serviceDef));
        this.ServicesByEmployees = {};

        this.EmployeeCache = employeeCache
            .filter(n => n.IsInactive === false)
            .map(employee => this.prepareEmployeeForCache(employee, serviceDefinitionModelCache, true));

        this.EmployeeCacheWithInactive = employeeCache
            .map(employee => this.prepareEmployeeForCache(employee, serviceDefinitionModelCache, false));

        this.EmployeeCacheWithInactiveByContactFacetId = this.EmployeeCacheWithInactive.toDictionary(p => p.ContactFacet_id.toLowerCase());

        this.ServiceDefinitionCache = Immutable.List(serviceDefinitionModelCache);

        let comboModels: ServiceComboDefinitionModel[] = [];
        let combos: { [comboId: string]: ServiceComboDefinitionModel } = {};

        serviceDefinitionComboCache
            .forEach(x => {
                if (Object.keys(combos).indexOf(x.ComboId.toString()) == -1)
                    combos[x.ComboId.toString()] = new ServiceComboDefinitionModel(x);

                combos[x.ComboId.toString()].AddServiceDefinition(x.ServiceDefinitionId, x.IsPrimaryEmployeeService);
            });

        Object.keys(combos).forEach(x => comboModels.push(combos[x]));

        this.ServiceDefinitionComboCache = Immutable.List(comboModels);
        this.refreshClinicianArrays();
    }

    public rebindServiceComboDefinitionToCache(comboDef: ServiceComboDefinition): void {
        let newServiceComboDefinitionModel = new ServiceComboDefinitionModel(comboDef);

        // get service definition
        if (comboDef.ServiceDefinitionIds != null)
            comboDef.ServiceDefinitionIds.forEach(x => newServiceComboDefinitionModel.AddServiceDefinition(x.ServiceDefinitionId, x.IsPrimaryService));

        let cachedServiceComboDefinitionList = (this.ServiceDefinitionComboCache != null ? this.ServiceDefinitionComboCache.toArray() : []);

        let currentServiceComboDefinition = cachedServiceComboDefinitionList
            .firstOrDefault(x => x.Model.ComboId == newServiceComboDefinitionModel.Model.ComboId);

        // set new combo definition in current combo cache
        if (currentServiceComboDefinition != null && cachedServiceComboDefinitionList.length > 0) {
            let idx = cachedServiceComboDefinitionList.indexOf(currentServiceComboDefinition);
            cachedServiceComboDefinitionList[idx] = newServiceComboDefinitionModel;
        }
        else
            cachedServiceComboDefinitionList.push(newServiceComboDefinitionModel);

        // reset combo definition cache
        this.ServiceDefinitionComboCache = Immutable.fromJS(cachedServiceComboDefinitionList);
    }

    public rebindServiceDefinitionToCache(serviceDef: ServiceDefinition): void {
        const serviceDefinitionCache = this.ServiceDefinitionCache
            .map(p => p.Model)
            .toArray()
            .upsert(serviceDef, cur => cur.Id == serviceDef.Id);

        this.BindEmployeesAndServices(
            serviceDefinitionCache,
            this.EmployeeCache,
            this.ServiceDefinitionComboCache.map(p => p.Model).toArray()
        );
    }

    public rebindServiceToCache(serviceDef: ServiceDefinitionDTO): void {
        let newServiceDefinitionModel = new ServiceDefinitionModel(serviceDef);
        let cachedServiceDefinitionList = this.ServiceDefinitionCache.toArray();

        let currentServiceDefinition = cachedServiceDefinitionList
            .firstOrDefault(x => x.Model.Id == newServiceDefinitionModel.Model.Id);

        // set new service definition in current service cache
        if (currentServiceDefinition != null) {
            let idx = cachedServiceDefinitionList.indexOf(currentServiceDefinition);

            cachedServiceDefinitionList[idx] = newServiceDefinitionModel;
        }
        else
            cachedServiceDefinitionList.push(newServiceDefinitionModel);

        // reset service in cached employee`s services
        let employeesContactIdsThatShouldHaveService = serviceDef.EmployeesContactFacetIds;
        let employeesContactIdsThatHadService = this.EmployeeCache
            .filter(emp => emp.ServicesIDsOffered.some(service => service.DefId == newServiceDefinitionModel.Model.Id))
            .map(emp => emp.ContactFacet_id);
        let employeesContactIdsWithServiceRemoved = employeesContactIdsThatHadService
            .filter(x => employeesContactIdsThatShouldHaveService.indexOf(x) == -1);
        employeesContactIdsThatShouldHaveService
            .forEach(employeeContactId => {
                let employee = this.EmployeeCache
                    .firstOrDefault(cachedEmployee => cachedEmployee.ContactFacet_id == employeeContactId);

                if (employee != null) {
                    // remove service from offered service of employes if employee was removed from service
                    if (employeesContactIdsWithServiceRemoved.indexOf(employee.ContactFacet_id) > -1) {
                        employee.ServicesIDsOffered = employee.ServicesIDsOffered.filter(s => s.Id != serviceDef.Id);
                        this.clearEmployeeFromServiceCache(employee, cachedServiceDefinitionList);
                    }

                    // add service to employee if new service
                    else if (employee.ServicesIDsOffered.map(s => s.DefId).indexOf(serviceDef.Id) == -1) {
                        let employeeServiceCacheInfo = serviceDef.EmployeeServices.firstOrDefault(e => e.EmployeeId == employee.ContactFacet_id && e.DefId == serviceDef.Id);
                        if (employeeServiceCacheInfo)
                            employee.ServicesIDsOffered.push(employeeServiceCacheInfo);
                    }

                    // replace new service info from response into employee (e.g to ensure IsActive is correctly set)
                    else {
                        let idx = employee.ServicesIDsOffered.map(s => s.DefId).indexOf(serviceDef.Id);
                        let employeeServiceCacheInfo = serviceDef.EmployeeServices.firstOrDefault(e => e.EmployeeId == employee.ContactFacet_id && e.DefId == serviceDef.Id);
                        if (employeeServiceCacheInfo)
                            employee.ServicesIDsOffered[idx] = employeeServiceCacheInfo;
                    }

                    // add service to employee offered service
                    this.prepareEmployeeForCache(employee, cachedServiceDefinitionList, true);
                }
            });

        // remove service from employees that had it - but no longuer have it according to new service definition
        employeesContactIdsWithServiceRemoved
            .forEach(contactId => {
                let employee = this.EmployeeCache
                    .firstOrDefault(cachedEmployee => cachedEmployee.ContactFacet_id == contactId);

                if (employee != null) {
                    employee.ServicesIDsOffered = employee.ServicesIDsOffered.filter(s => s.DefId != serviceDef.Id);
                    this.clearEmployeeFromServiceCache(employee, cachedServiceDefinitionList);
                    this.prepareEmployeeForCache(employee, cachedServiceDefinitionList, true);
                }
            });

        // reset service definition cache
        this.ServiceDefinitionCache = Immutable.fromJS(cachedServiceDefinitionList);
    }

    public bindSites(siteCache: Site[]): void {
        // don't include the "parentSite" in SiteCache (i.e. sites with no parentSiteId)
        this.SiteCache = siteCache
            .filter(x => x.ParentSiteId != null)
            .map(x => SitesModel.fromSiteResponse(x));

        this.ParentSiteCache = siteCache
            .filter(x => x.ParentSiteId == null)
            .map(x => SitesModel.fromSiteResponse(x));

        this.SitesAddressCache = siteCache.flatten(site => site.Adresses.map(p => Address.FromResponseModel(p)));
    }

    public async bindFavoriteDiagnoses(): Promise<void> {
        const response = await Client.postAsync<{ FavoriteDiagnoses: FavoriteDiagnosisComposite[] }>(
            ServerOperations.Server.Myle_GetFavoriteDiagnoses,
            {
                EmployeeId: sessionStore.getCurrentEmployee().ContactFacetId
            }
        );
        this.FavoriteDiagnoses = Immutable.List(PatientMedicalSummaryHelper.InitDiagnoses(response.data.FavoriteDiagnoses));
    }

    public GetLookupById(lookupId: string): FlatLookupView {
        let id = (lookupId || "").toLowerCase();

        return this.LookupsDict[id];
    }

    public GetSpecialtyById(id: string): LicenceOrganisationSpecialisation {
        if (IsNullOrWhiteSpace(id))
            return null;

        return this.LicenseOrganizationSpecializationsById[id];
    }

    public getLookupByContactPointType(contactPointType: ContactPointType): FlatLookupView {
        let contactPointTypesLookups = this.FindLookupsByTypeCode("CONTACTPOINTTYPE");

        switch (contactPointType) {
            case ContactPointType.Work:
                return contactPointTypesLookups.firstOrDefault(w => w.LookupCode === "WORK");

            case ContactPointType.Other:
                return contactPointTypesLookups.firstOrDefault(w => w.LookupCode === "OTHERCONTACTPOINT");

            case ContactPointType.Personal:
                return contactPointTypesLookups.firstOrDefault(w => w.LookupCode === "PERSONAL");

            default:
                break;
        }
    }

    public getLookupByPhoneType(phoneType: PhoneType): FlatLookupView {
        let phoneTypesLookups = this.FindLookupsByTypeCode("PHONETYPE");

        switch (phoneType) {
            case PhoneType.Phone:
                return phoneTypesLookups.firstOrDefault(w => w.LookupCode === "PHONE");

            case PhoneType.Fax:
                return phoneTypesLookups.firstOrDefault(w => w.LookupCode === "FAX");

            case PhoneType.Mobile:
                return phoneTypesLookups.firstOrDefault(w => w.LookupCode === "MOBILE");

            case PhoneType.Pager:
                return phoneTypesLookups.firstOrDefault(w => w.LookupCode === "PAGER");

            default:
                break;
        }
    }

    public GetAppointmentDescription(subject: string, serviceDefinitionId: string, comboId?: number): string {
        const serviceDefinitionName = this.GetServiceDefinitionName(serviceDefinitionId);

        subject = subject?.trim();
        serviceDefinitionName?.trim();

        let label = "";
        if (subject && serviceDefinitionName)
            label = `${serviceDefinitionName} - ${subject}`;
        else if (subject)
            label = subject;
        else if (serviceDefinitionName)
            label = serviceDefinitionName;

        const comboName = this.GetComboName(comboId)?.trim();

        return comboName
            ? `${label} (${comboName})`
            : label;
    }

    public GetAppointmentServiceDescription(serviceDefinitionId: string, comboId?: number): string {
        const serviceDefinitionName = this.GetServiceDefinitionName(serviceDefinitionId)?.trim();
        const comboName = this.GetComboName(comboId)?.trim();

        if (serviceDefinitionName && comboName)
            return `${serviceDefinitionName} (${comboName})`;

        if (serviceDefinitionName)
            return serviceDefinitionName;

        comboName ?? "";
    }

    public GetServiceDefinitionById(id: string): ServiceDefinitionModel {
        if (id == null)
            return null;

        return this.ServiceDefinitionCache
            .filter(p => p.Model.Id === id)
            .first();
    }

    public GetComboDefinitionById(id: number): ServiceComboDefinitionModel {
        if (id == null)
            return null;

        return this.ServiceDefinitionComboCache
            .filter(p => p.Model.ComboId === id)
            .first();
    }

    public GetServiceDefinitionName(id: string): string {
        const serviceDefinition = this.GetServiceDefinitionById(id);

        return serviceDefinition && !serviceDefinition.IsAdHoc
            ? serviceDefinition.Name
            : "";
    }

    public GetComboName(id: number): string {
        return this.GetComboDefinitionById(id)?.Name ?? "";
    }

    /**
     * Fetch translations from the backend API.
     * @param locale The locale to fetch.
     * @param onSuccess Called when the translations are loaded.
     */
    public async RequestApplicationStringAsync(locale: Locale, onSuccess?: () => void): Promise<void> {
        if (this.AreTranslationsLoaded(locale))
            return onSuccess?.();

        this.LoadingLocales[locale] = [...this.LoadingLocales[locale] ?? [], onSuccess];
        if (this.LoadingLocales[locale].length > 1)
            return;

        const response = await Client.postAsync<{ Resources: { [index: string]: string; }; Lookups: { [index: string]: string; }; }>(
            ServerOperations.Server.Myle_Resources,
            { Locale: locale }
        );

        if (!response.isSuccess) {
            console.error(response.errors);
            return;
        }

        this.LoadApplicationString(response.data, locale);
        this.EmitChangeToListeners();

        for (let callback of this.LoadingLocales[locale])
            callback?.();

        delete this.LoadingLocales[locale];
    }

    /**
     * Request to toggle favorite of a list of medications by API
     * @param {string} prescriptionId
     * @param {boolean} shouldRemove
     * @param {boolean} shouldReloadFavorites
     */
    public async requestToggleFavorite(prescriptionId: string, shouldRemove: boolean, shouldReloadFavorites: boolean): Promise<void> {
        const currentEmployeeContactFacetId: string = sessionStore.getCurrentEmployee()?.ContactFacetId;

        if (!currentEmployeeContactFacetId) {
            return;
        }

        const requestData = {
            EmployeeId: currentEmployeeContactFacetId,
            PrescriptionId: prescriptionId,
            IsRemove: shouldRemove,
            ReloadFavorites: shouldReloadFavorites
        };

        const response = await Client.postAsync<ToggleFavoriteResponse>(
            ServerOperations.Server.Myle_ToggleFavorite,
            requestData
        );

        if (response.errors?.length === 0) {
            await this.toggleFavorite(response.data);
        }
    }

    /**
     * Get favorite prescription
     */
    public async requestReloadFavoritePrescription(): Promise<void> {
        const currentEmployeeContactFacetId: string = sessionStore.getCurrentEmployee()?.ContactFacetId;

        if (!currentEmployeeContactFacetId) {
            return;
        }

        const requestData = {
            EmployeeId: currentEmployeeContactFacetId
        };

        const response = await Client.postAsync<GetFavoritePrescriptionResponse>(
            ServerOperations.Server.Myle_GetFavoritePrescription,
            requestData
        );

        if (response.errors?.length === 0) {
            this.reloadFavoritePrescription(response.data);
        }
    }

    public findPreventiveCareCriteria(id: Guid): PreventiveCareCriteria {
        return this.PreventiveCareCriteriaList.firstOrDefault(p => p.Id === id);
    }

    public LoadApplicationString(jsonObject: { Resources: { [index: string]: string }, Lookups: { [index: string]: string } }, lang: Locale): void {
        this.ResourceStrings[lang] = new ApplicationStrings(lang.toLowerCase(), jsonObject.Resources);
        this.LookupStrings[lang] = new ApplicationStrings(lang.toLowerCase(), jsonObject.Lookups);
    }

    public FindLookupsByTypeCode(type: string): FlatLookupView[] {
        if (this.LookupsByTypeCodeCacheDict[type] == null) {
            let q = this.Lookups.filter(i => i.LookupTypeCode.toUpperCase() === type.toUpperCase());
            this.LookupsByTypeCodeCacheDict[type] = q;
            return q;
        }
        else
            return this.LookupsByTypeCodeCacheDict[type];
    }

    public FindLookupsByPartialType(type: string): FlatLookupView[] {
        let partialMatchRegex = new RegExp(type, "i");
        return this.Lookups
            .filter(l => {
                let m = l.LookupTypeCode.match(partialMatchRegex);
                return m && m.length > 0;
            });
    }

    public FindLookupByLookupCode(lookupCode: string, typeCode: string = null): FlatLookupView {
        return this
            .GetLookupByLookupCode(lookupCode)
            .firstOrDefault(l => typeCode == null || l.LookupTypeCode.toUpperCase() == typeCode.toUpperCase());
    }

    public GetLocalizedValueByLookupId(id: string, locale: Locale = null): string {
        let lookup = this.GetLookupById(id);
        return lookup && lookup.GetValue(locale) || "";
    }

    public GetCodeByLookupId(id: string): string | null {
        return this.GetLookupById(id)?.LookupCode ?? null;
    }

    public IsHighPriority(id: string): boolean {
        const value = this.GetLocalizedValueByLookupId(id, Locale.en);
        return value === "High";
    }

    public GetCliniciansPersonsByContactFacetId(clinicianContactFacetId: string): Person {
        return this.CliniciansWithInactive
            .firstOrDefault(x => x.ContactFacetId == clinicianContactFacetId);
    }

    public GetCliniciansPersonsByContactFacetIdOrEmpty(clinicianContactFacetId: string): Person {
        return this.CliniciansWithInactive
            .firstOrDefault(x => x.ContactFacetId == clinicianContactFacetId, new Person());
    }

    public GetCliniciansPersonsByContactId(id: string): Person {
        return this.CliniciansWithInactive
            .firstOrDefault(x => x.ContactId == id);
    }

    public GetCliniciansPersonsByLicenceNumberList(LicenceNumbers: string[]): Person[] {
        return this.CliniciansWithInactive
            .filter(p => LicenceNumbers.includes(p.Licence));
    }

    public GetLookupIdForProvince(province: CanadaState): string {
        const lookup = this.FindLookupByLookupCode(province, CanadaState.Code);
        return lookup?.LookupID;
    }

    public GetCurrentEmployee(): Employee {
        return this.GetEmployeeByContactIdOrDefault(sessionStore.individualContactId);
    }

    public getDropDownOptionByType(code: string): DropDownOption[] {
        return this.DropDownOptionsByTypCacheDict.get(code);
    }

    public getDropDownOptionByTypeAndId(code: string, id: string): DropDownOption[] {
        return this
            .getDropDownOptionByType(code)
            .filter(x => x.model.Id == id);
    }

    public getTestDefinitionById(id: number): ScreeningTestDefinition {
        return this.screeningTestDefinitions
            .firstOrDefault(x => x.Id === id);
    }

    public getProfileById(id: number): ScreeningTestProfile {
        if (!this.screeningTestProfiles)
            return null;
        return this.screeningTestProfiles
            .firstOrDefault(x => x.Id === id);
    }

    public getTestDefinitionsByProfileId(profileId: number): ScreeningTestDefinition[] {
        if (!profileId || !this.screeningTestProfileDefinitions)
            return [];

        return this.screeningTestDefinitions
            .filter(x =>
                this.screeningTestProfileDefinitions
                    .some(y => y.ScreeningTestProfileId === profileId && y.ScreeningTestDefinitionId === x.Id)
            );
    }

    /**
     *
     * @param id Inactivable_Id
       @returns Myle.Core.Entities.Composites.EmployeeComposite or NULL if employee not found
     */
    public GetEmployeeByContactIdOrDefault(id: string): Employee {
        if (!id)
            return null;

        return this.EmployeeCacheWithInactive
            .firstOrDefault(e => e.Contact_id.toLocaleLowerCase() === id.toLocaleLowerCase());
    }

    public GetEmployeeByContactIdOrEmpty(id: string): Employee {
        return this.EmployeeCacheWithInactive
            .firstOrDefault(e => e.Contact_id.toLocaleLowerCase() === id.toLocaleLowerCase(), new Employee());
    }

    /**
     *
     * @param id ContactFacet_id
       @returns Myle.Core.Entities.Composites.EmployeeComposite or NULL if employee not found
     */
    public GetEmployeeByContactFacetId(id: string): Employee {
        if (!id)
            return null;

        return this.EmployeeCacheWithInactive
            .firstOrDefault(e => e.ContactFacet_id.toLocaleLowerCase() === id.toLocaleLowerCase());
    }

    public GetEmployeeByUserId(id: string): Employee {
        if (!id)
            return null;

        return this.EmployeeCacheWithInactive
            .firstOrDefault(e => e.User_id.toLocaleLowerCase() === id.toLocaleLowerCase());
    }

    public GetEmployeesContactFacetIdsBySitesIds(siteIds: string[]): string[] {
        return this.EmployeeCacheWithInactive
            .filter(e => e.AssociatedSites.some(siteId => siteIds.contains(siteId)))
            .map(e => e.ContactFacet_id);
    }

    public GetEmployeeByContactFacetIdDictionary(id: string): Employee {
        return this.EmployeeCacheWithInactiveByContactFacetId[id.toLowerCase()] ?? null;
    }

    public GetInactiveEmployees(): Employee[] {
        return this.EmployeeCacheWithInactive
            .filter(e => e.IsInactive === true);
    }

    public GetActiveEmployees(): Employee[] {
        return this.EmployeeCache
            .filter(e => e.IsInactive === false);
    }

    public GetClinicianByLicence(licence: string): Person {
        if (IsNullOrWhiteSpace(licence))
            return null;

        return this.CliniciansWithInactive.filter(
            p =>
                p.EmployeeModel.Licences
                && p.EmployeeModel.Licences.length > 0
                && p.EmployeeModel.Licences.some(license => license.LicenceNumber == licence || license.LicenceNumber == ("R" + licence))
        ).firstPreferredOrDefault(p => !p.IsInactive);
    }

    public GetClinicianByRamqNumber(ramqNumber: string): Person {
        if (IsNullOrWhiteSpace(ramqNumber))
            return null;

        return this.CliniciansWithInactive.filter(
            p => p.EmployeeModel.RamqNumber == ramqNumber
        ).firstPreferredOrDefault(p => !p.IsInactive);
    }

    public GetEmployeeByLicenceFirstOrDefault(licence: string): Employee {
        let clinician = this.CliniciansWithInactive
            .filter(x => x.EmployeeModel.FirstLicenceNumber == licence)
            .firstPreferredOrDefault(p => !p.IsInactive);
        return clinician && clinician.EmployeeModel;
    }

    public GetTaskTypes(): KeyValuePair<string, string>[] {
        return this
            .FindLookupsByTypeCode("TaskType")
            .sortByProperty(p => p.GetValue())
            .map(f => new KeyValuePair(f.PrimaryKeyID, f.GetValue()));
    }

    public GetPriorities(): KeyValuePair<string, string>[] {
        return this
            .FindLookupsByTypeCode("TaskPrority")
            .sortByProperty(p => p.GetValue())
            .map(f => new KeyValuePair(f.PrimaryKeyID, f.GetValue()));
    }

    public GetHRMStatusList(locale: Locale = null): KeyValuePair<string, string>[] {
        locale = locale ?? sessionStore.locale;

        return this
            .FindLookupsByTypeCode("HRMSTATUS")
            .map(flview => new KeyValuePair(flview.LookupID, flview.GetValue(locale)));
    }

    /**
     * Get whether a translation exists in the cache.
     * @param key The unique translation key.
     */
    public HasString(key: string, locale: Locale = null): boolean {
        locale = locale ?? sessionStore.locale;
        return (this.ResourceStrings[locale]?.[key] ?? this.LookupStrings[locale]?.[key]) != undefined;
    }

    /**
     * Get a translation from the cache.
     * @param key The unique translation key.
     * @param tokens An object containing token values to substitute in the string.
     * @param locale The locale code for which to get translations. This must already be loaded via {@link RequestApplicationStringAsync}.
     */
    public GetString(key: string, tokens: object = {}, locale: Locale = null): string {
        locale = locale ?? sessionStore.locale;
        let message = this.HasString(key, locale ?? sessionStore.locale)
            ? (this.ResourceStrings[locale][key] || this.LookupStrings[locale][key])
            : key?.toUpperCase();

        for (const key of Object.keys(tokens || {}))
            message = message.replaceAll("{{" + key + "}}", tokens[key], true);

        return message;
    }

    /**
     * Returns whether vocabulary strings have been loaded for specified locale.
     * Checks both ResourceStrings and LookpStrings
     * @param locale Locale for which to run the check.
     */
    public AreTranslationsLoaded(locale: Locale): boolean {
        return !!(this.ResourceStrings[locale] && this.LookupStrings[locale]);
    }

    /**
     * Get the health card ID translation for a region.
     *
     * @param countryId The lookup ID for the health card's country.
     * @param stateId The lookup ID for the health card's subdivision (e.g. province/state).
     */
    public GetHealthCardLabel(countryId: string, stateId: string): string {
        // get country if needed
        if (!countryId && stateId) {
            let country = cacheStore.GetCountryForRegion(stateId);
            countryId = country && country.LookupID;
        }

        // get regional translation
        let mexicoId = this.FindLookupByLookupCode("CNMEXICO").LookupID;
        let quebecId = this.FindLookupByLookupCode("CanadaState_QC").LookupID;

        if (countryId && countryId == mexicoId)
            return this.GetString("HealthCard_CURP");
        if (stateId && stateId == quebecId)
            return this.GetString("HealthCard_NAM");

        return this.GetString("HealthCard");
    }

    public GetSiteById(siteId: string): SitesModel {
        return this.SiteCache.firstOrDefault(x => x.Model.Id == siteId)
            || this.ParentSiteCache.firstOrDefault(x => x.Model.Id == siteId); // retry with parent site
    }

    public GetSiteNameById(siteId: string): string {
        let result = this.SiteCache.firstOrDefault(x => x.Model.Id == siteId);
        return result
            ? result.Model.ClinicalName
            : "";
    }

    public GetSitesContextIdsCommaSeparated(): string {
        return this.SiteCache
            .map(site => site.Model.LabContext)
            .filter(ids => ids != null)
            .map(ids => ids.split(","))
            .flat()
            .distinct()
            .join(",");
    }

    public GetCostCenterNameById(centerId: string): string {
        let costCenter = this.GetCostCenterById(centerId);
        return costCenter ? costCenter.Name : "";
    }

    public GetCostCenterById(centerId: string): PrivateBillCostCenter {
        return this.CostCenterCache && this.CostCenterCache.length > 0
            ? this.CostCenterCache.firstOrDefault(x => x.ID == centerId)
            : null;
    }

    /**
     * Update a tab state.
     * @param key The unique key for the tab to update.
     * @param topCount The top badge value, or null to hide it.
     * @param bottomCount The bottom badge value, or null to hide it.
     * @param pendingTopCount The top badge value, or null to hide it.
     * @param pendingBottomCount The bottom badge value, or null to hide it.
     * @param disableWaitTime The disable wait time.
     * @param tooltip The tooltip to show counters descriptions.
     */
    public UpdateTab(
        key: MyleTabKey,
        topCount: number | null = null,
        bottomCount: number | null = null,
        pendingTopCount: number | null = null,
        pendingBottomCount: number | null = null,
        disableWaitTime: boolean = false,
        tooltip: MyleMenuTabTooltip = null
    ): void {
        // find matching tab
        let tab = this.Tabs.firstOrDefault(tab => tab.key === key);
        if (!tab)
            return;

        // update counters
        tab.showCounts = this.shouldShowCounts(topCount, bottomCount, this.getTooltipList(key, tooltip));
        tab.topCount = topCount || 0;
        tab.bottomCount = bottomCount || 0;
        tab.topPendingCount = pendingTopCount || 0;
        tab.bottomUrgentPendingCount = pendingBottomCount || 0;
        tab.tooltip = tooltip;

        this.updateLockedTab(tab, disableWaitTime);
    }

    /**
     * Update a tab state.
     * @param key The unique key for the tab to update.
     * @param path The new path that the tab should have
     * @param bottomCount The bottom badge value, or null to hide it.
     */
    public UpdateTabsPath(key: MyleTabKey, path: string, disableWaitTime: boolean = false): void {
        const tab = this.Tabs.find(p => p.key === key);

        if (!tab) {
            return;
        }

        tab.path = path;
        this.updateLockedTab(tab, disableWaitTime);
    }

    /**
     * Update a aside tab state.
     * @param key The unique key for the tab to update.
     * @param topCountAside The top aside badge value, or null to hide it.
     * @param bottomCountAside The bottom aside badge value, or null to hide it.
     */
    public updateUnmanagedFaxesCounter(key: MyleTabKey, unmanagedFaxCount: number | null = null, urgentFaxCount: number | null = null, disableWaitTime: boolean = false): void {
        // find matching tab
        let tab = this.Tabs.firstOrDefault(tab => tab.key === key);
        if (!tab)
            return;

        // update counters
        const documentsCounters = new DocumentsCounters(documentsStore.DocumentsModel.get("DocumentNonApprovedCount"), unmanagedFaxCount, documentsStore.DocumentsModel.get("DocumentNonApprovedAndUrgentCount"), urgentFaxCount);
        this.UpdateTab(
            MyleTabKey.Documents,
            documentsStore.DocumentsModel.get("DocumentNonApprovedCount"),
            documentsStore.DocumentsModel.get("DocumentNonApprovedAndUrgentCount"),
            unmanagedFaxCount,
            urgentFaxCount,
            disableWaitTime,
            { documentsCounters: documentsCounters }
        );
    }

    public RefreshUserSettings(): void {
        let action = new LoginAction();
        action.loadUserSettings(sessionStore.userId);
    }

    public RefreshPAListDisplaySettings(settings: PAListDisplaySettings): void {
        if (this.UserSettings != null)
            this.UserSettings.PAListDisplaySettings = settings;
    }

    public GetAppointmentStateLookups(): FlatLookupView[] {
        return this
            .FindLookupsByTypeCode("SITEMGMT.APPOINTMENTS.STATE")
            .sortByProperty(p => p.LookupPosition);
    }

    public GetSingleAppointmentStateLookup(lookupCode: string): FlatLookupView[] {
        return this
            .GetAppointmentStateLookups()
            .filter(e => e.LookupCode === lookupCode);
    }

    public GetGenderLookupId(genderString: string): string {
        if (!genderString)
            return null;

        genderString = genderString.trim().toUpperCase();

        if (genderString === "M" || genderString === "MALE" || genderString === "H" || genderString === "HOMME")
            return this.FindLookupByLookupCode("MALE").LookupID;
        if (genderString === "F" || genderString === "FEMALE" || genderString === "F" || genderString === "FEMME")
            return this.FindLookupByLookupCode("FEMALE").LookupID;
    }

    public GetSites(target: CheckboxTarget): SiteUIModel[] {
        return this.SiteCache
            .map(s => {
                let site = SiteUIModel.FromCompositeObject(s);
                site.Checked = true;
                site.Target = target;
                site.Model = s.Model;
                return site;
            });
    }

    public getCostCenter(target: CheckboxTarget, center: PrivateBillCostCenter): CostCenterUIModel {
        let costCenter = CostCenterUIModel.FromCompositeObject(center);
        costCenter.Checked = true;
        costCenter.Target = target;
        costCenter.Model = center;
        return costCenter;
    }

    public GetCostCenters(target: CheckboxTarget): CostCenterUIModel[] {
        return this.CostCenterCache
            .map(p => this.getCostCenter(target, p));
    }

    public getCostCenterBySiteId(siteId: string): PrivateBillCostCenter[] {
        return this.CostCenterCache.filter(x => x.SiteId === siteId);
    }

    public IsMultiSite(): boolean {
        return this.SiteCache.length > 1;
    }

    public GetCliniciansAsEmployees(target: CheckboxTarget, includeDeactivated: boolean = false): EmployeeUIModel[] {
        let employees = includeDeactivated ? this.EmployeeCacheWithInactive : this.EmployeeCache;

        return employees
            .map(p => {
                let employee = EmployeeUIModel.fromCompositeObject(p);
                employee.Target = target;
                return employee;
            });
    }

    public GetCliniciansAsPersons(): Person[] {
        return this.EmployeeCache
            .map(p => Person.FromEmployee(p));
    }

    public GetCheckboxesByLookupTypeCode(lookupTypeCode: string, target: CheckboxTarget = null, checked: boolean = true): CheckboxUIModel[] {
        return this
            .FindLookupsByTypeCode(lookupTypeCode)
            .map(x => {
                let ui = new CheckboxUIModel();
                ui.Id = x.LookupID;
                ui.Name = this.GetLocalizedValueByLookupId(x.LookupID);
                ui.Target = target;
                ui.Checked = checked;
                ui.Position = x.LookupPosition;
                return ui;
            });
    }

    public GetPrioritiesLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeCode("TaskPrority");
    }

    public FindLookupsByTypeName(type: string): FlatLookupView[] {
        if (type == null)
            return [];

        if (this.LookupsByTypeNameCacheDict[type] == null) {
            let q = this.Lookups.filter(i => i.LookupTypeName.toUpperCase() === type.toUpperCase());
            this.LookupsByTypeNameCacheDict[type] = q;
            return q;
        }
        else
            return this.LookupsByTypeNameCacheDict[type];
    }

    public GetCountryLookups(): FlatLookupView[] {
        return this
            .FindLookupsByTypeName(CountryNames.Code)
            .sortByProperty(p => p.LookupPosition)
            .filter(x => x.LookupCode != "CNOTHER") // remove "other country" cause it breaks things in silverlight
            .filter(lookup => cacheStore.ClinicSettings.EnableArmeniaCountryAndStates || lookup.LookupCode !== "CNARMENIA");
    }

    public GetCountryForRegion(regionLookupId: string): FlatLookupView {
        if (regionLookupId && regionLookupId.length > 0) {
            let regionLookup = this.GetLookupById(regionLookupId);
            let code = "CN" + regionLookup.LookupTypeCode.replace("State", "");

            return this.FindLookupByLookupCode(code);
        }

        return null;
    }

    public GetCountryRegionLookups(countryLookup: FlatLookupView): FlatLookupView[] {
        if (countryLookup) {
            let countryLookupCode = countryLookup.LookupCode.substring(2) + "State";
            return this.FindLookupsByTypeCode(countryLookupCode);
        }
        return [];
    }

    public GetDefaultCountryForActiveSite(): FlatLookupView | null {
        let activeSite = sessionStore.getCurrentEmployee().getActiveSite();
        if (activeSite) {
            if (activeSite.Model.Adresses && activeSite.Model.Adresses[0])
                return this.GetLookupById(activeSite.Model.Adresses[0].CountryLookupId);
        }

        return null;
    }

    public GetCountryIsoCodeByLookUpId(lookupId: string): string | null {
        const lookup = cacheStore.GetLookupById(lookupId)?.LookupCode;
        if (!lookup)
            return null;

        return cacheStore.CountryCache.firstOrDefault(p => p.Myle_LookupCode === lookup)?.Alpha2Code;
    }

    public GetStateCodeFromStateLookupId(stateLookupId: string): string {
        let result = "";
        if (stateLookupId != null) {
            let stateLookup = this.GetLookupById(stateLookupId);
            if (stateLookup != null) {
                try {
                    result = stateLookup.LookupCode.split("_")[1];
                }
                catch (e) { }
            }
        }
        return result;
    }

    public GetStateLookupIdFromStateCode(stateCode: string, stateLookupIds: FlatLookupView[]): string {
        try {
            let state = stateLookupIds
                .firstOrDefault(x => x.LookupCode.split("_")[1].toUpperCase() == stateCode.toUpperCase());

            if (state)
                return state.LookupID;
        }
        catch (e) { }
        return "";
    }

    /**
     * Returns the conuntry lookup that match with a country name ex Canada, or ca or return the default country for the active site
     * @param {string | countryName} countryName The name of the country to be search
     */
    public getCountryLookupByCountryNameOrDefaultActiveSite(countryName: string): FlatLookupView {
        let countryLookup: FlatLookupView = this.GetDefaultCountryForActiveSite();

        if (IsNullOrUndefined(countryName))
            return countryLookup;

        const upperCountryName = countryName.toUpperCase();
        const countryLookupCode = this.GetCountryLookupCodeByISOCodeAlpha2(upperCountryName);

        const countryMatch = this.GetCountryLookups()
            .firstOrDefault(
                p =>
                    (p.LookupCode === countryLookupCode)
                    || (p.en && p.en.toUpperCase() === upperCountryName)
                    || (p.fr && p.fr.toUpperCase() === upperCountryName)
                    || (p.esMX && p.esMX.toUpperCase() === upperCountryName),
                countryLookup
            );

        return countryMatch;
    }

    /**
     * Returns the region lookup that match with a province name ex QC Quebec(en) Québec(fr) or return the default region for the active site
     * @param {string | regionName} regionName The name of the region to be search
     * @param {FlatLookupView | countryLookup} countryLookup FlatLookupView for the country
     */
    public getRegionLookupIdOrDefaultActiveSite(regionName: string, countryLookup: FlatLookupView): string {
        let regionLookup = this.GetDefaultRegionForActiveSite();

        if (!regionName || !countryLookup)
            return regionLookup.LookupID;

        const upperRegionName = regionName.toUpperCase();
        const regionLookups = this.GetCountryRegionLookups(countryLookup);
        const regionMatch = regionLookups
            .firstOrDefault(
                p =>
                    (p.LookupCode.split("_")[1].toUpperCase() === upperRegionName)
                    || (p.en && p.en.toUpperCase() === upperRegionName)
                    || (p.fr && p.fr.toUpperCase() === upperRegionName)
                    || (p.esMX && p.esMX.toUpperCase() === upperRegionName),
                regionLookup
            );

        return regionMatch.LookupID;
    }

    public GetDefaultRegionForActiveSite(): FlatLookupView {
        let activeSite = sessionStore.getCurrentEmployee().getActiveSite();
        if (activeSite) {
            if (activeSite.Model.Adresses && activeSite.Model.Adresses[0])
                return this.GetLookupById(activeSite.Model.Adresses[0].StateLookupId);
        }

        return null;
    }

    public GetInsuranceProviders(): InsuranceProvider[] {
        return this.InsuranceProviderCache;
    }

    public GetReligions(): ReligionData[] {
        if (this.ReligionCache == null || this.ReligionCache == undefined)
            return [];
        return this.ReligionCache;
    }

    public GetPrefixIndividualLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeName("IndividualPrefix").sortByProperty(prefix => prefix.LookupPosition);
    }

    public GetSuffixIndividualLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeName("Individual Suffix");
    }

    public GetRepresentativeTypeLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeCode("REPRESENTATIVETYPE");
    }

    public GetContactPointTypeLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeCode("CONTACTPOINTTYPE");
    }

    public GetMaritalStatusLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeName("Marital Status");
    }

    public GetGenderLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeName("Gender");
    }

    public GetLanguagesLookup(): FlatLookupView[] {
        return this.FindLookupsByTypeName("Language");
    }

    public GetPrivateBillCostCenterNameLookup(): FlatLookupView[] {
        return this.FindLookupsByTypeName("PrivateBillCostCenterName");
    }

    public GetPatientStatusLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeName("Patient Status");
    }

    public GetClinicianPermitStatusLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeName("PermitStatusCode");
    }

    /**
     * Get user's external billing payment mode lookup.
     */
    public GetExternalBillingPaymentModeLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeCode(ExternalBillingPaymentMode.Code).sortByProperty(p => p.LookupPosition);
    }

    public GetClinicianSpecialityLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeName("Specialization_def").sortByProperty(x => x.LookupCode);
    }

    public GetClinicianPermitTypeLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeName("PermitTypeCode").sortByProperty(x => x.LookupPosition);
    }

    public GetRelationshipTypeLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeName("RELATIONLINKS");
    }

    public GetCliniciansWithClinicalEmployeeType(includeInactives: boolean = false): Person[] {
        return this
            .GetClinicians(includeInactives)
            .filter(x => x.EmployeeModel.Type === EmployeeType.Practician);
    }

    public GetTitleLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeName("TitleType");
    }

    public GetRelationshipLookupsTuples(currentPatientGender: Gender = Gender.Male): [FlatLookupView, FlatLookupView][] {
        if (currentPatientGender == Gender.Male && this.memoizeRelationshipTupleMale != null)
            return this.memoizeRelationshipTupleMale;
        else if (this.memoizeRelationshipTupleFemale != null)
            return this.memoizeRelationshipTupleFemale;

        let resultMale: [FlatLookupView, FlatLookupView][] = [];
        let resultFemale: [FlatLookupView, FlatLookupView][] = [];

        let relationshipLookups = this
            .FindLookupsByTypeName("RELATIONLINKS")
            .sortByProperty(x => x.LookupPosition);

        relationshipLookups.forEach(x => {
            let rMale: [FlatLookupView, FlatLookupView];
            let rFemale: [FlatLookupView, FlatLookupView];

            if (x.LookupCode == "RLGrandparent") {
                rMale = [x, this.FindLookupByLookupCode("RLGrandchild")];
                rFemale = [x, this.FindLookupByLookupCode("RLGrandchild")];
            }

            if (x.LookupCode == "RLGrandchild") {
                rMale = [x, this.FindLookupByLookupCode("RLGrandparent")];
                rFemale = [x, this.FindLookupByLookupCode("RLGrandparent")];
            }

            if (x.LookupCode == "RLFather" || x.LookupCode == "RLMother") {
                rMale = [x, this.FindLookupByLookupCode("RLChild")];
                rFemale = [x, this.FindLookupByLookupCode("RLChild")];
            }

            if (x.LookupCode == "RLChild") {
                rMale = [x, this.FindLookupByLookupCode("RLFather")];
                rFemale = [x, this.FindLookupByLookupCode("RLMother")];
            }

            if (x.LookupCode == "RLSibling") {
                rMale = [x, this.FindLookupByLookupCode("RLSibling")];
                rFemale = [x, this.FindLookupByLookupCode("RLSibling")];
            }

            if (x.LookupCode == "RLSpouse") {
                rMale = [x, this.FindLookupByLookupCode("RLSpouse")];
                rFemale = [x, this.FindLookupByLookupCode("RLSpouse")];
            }

            if (x.LookupCode == "RLOther") {
                rMale = [x, this.FindLookupByLookupCode("RLOther")];
                rFemale = [x, this.FindLookupByLookupCode("RLOther")];
            }

            if (rMale)
                resultMale.push(rMale);
            if (rFemale)
                resultFemale.push(rFemale);
        });

        if (currentPatientGender == Gender.Male) {
            this.memoizeRelationshipTupleMale = resultMale;
            return resultMale;
        }
        else {
            this.memoizeRelationshipTupleFemale = resultFemale;
            return resultFemale;
        }
    }

    public GetClinicians(includeInactives: boolean = true): Person[] {
        let employees = includeInactives
            ? this.EmployeeCacheWithInactive
            : this.EmployeeCache.filter(x => !x.IsInactive);

        return employees
            .map(clinician => Person.FromEmployee(clinician));
    }

    public GetActiveCliniciansAndEmployeeGroups(): Person[] {
        return this.EmployeeCache
            .map(clinician => Person.FromEmployee(clinician))
            .concat(this.GetClinicianGroups());
    }

    public GetClinicianGroups(): Person[] {
        return this.EmployeeGroupCache
            .filter(p => !p.IsInactive)
            .map(x => {
                let groupId = x.Id;
                let person = new Person();
                // for now lets set both contactfacetId and contactId to the group'ID
                person.ContactFacetId = groupId;
                person.ContactId = groupId;
                person.Name = x.Name;
                person.IsPersonGroup = true;
                person.EmployeeGroupModel = x;
                person.GroupEmployeeModels = x.EmployeeContactFacetIds;
                return person;
            });
    }

    public GetClinicianDoctors(licenceFormatMatch?: (license: License) => boolean): Person[] {
        return this
            .GetClinicians(false)
            .filter(x =>
                x.EmployeeModel != null

                // has licence (and optional licence checks)
                && x.EmployeeModel.Licences
                && x.EmployeeModel.Licences.length > 0
                && x.EmployeeModel.Licences[0].LicenceNumber.length > 0
                && (!licenceFormatMatch || licenceFormatMatch(x.EmployeeModel.Licences[0]))

                // has doctor title
                && EmployeeTitleHelper.isDoctor(Employee.getTitle(x.EmployeeModel))
            )
            .sortByProperty(x => x.Name);
    }

    public GetClinicianResidents(): Person[] {
        return this
            .GetClinicians(false)
            .filter(
                x =>
                    x.EmployeeModel != null
                    && (
                        // has resident license
                        (
                            x.EmployeeModel.Licences
                            && x.EmployeeModel.Licences.length > 0
                            && x.EmployeeModel.Licences[0].LicenceNumber.length == 6
                            && x.EmployeeModel.Licences[0].LicenceNumber.substr(0, 1).toUpperCase() == "R"
                        )

                        // has resident title
                        || Employee.getTitle(x.EmployeeModel) === EmployeeTitle.Resident
                    )
            )
            .sortByProperty(p => p.Name);
    }

    public GetIPS(): Person[] {
        return this
            .GetClinicians(false)
            .filter(x =>
                x.EmployeeModel != null

                // has IPS title
                && Employee.getIssuingOrgRule(x.EmployeeModel)?.Title === EmployeeTitle.NursePractitioner
            )
            .sortByProperty(x => x.Name);
    }

    public GetRAMQTypeRepresentant(includeParents: boolean = true): [string, string][] {
        let result: [string, string][] = [];

        if (includeParents)
            result.push(["MOP", this.GetString("MotherOrFatherLabel")]);

        result.push(["ACC", this.GetString("ChaperoneLabel")]);
        result.push(["CUR", this.GetString("CuratorLabel")]);
        result.push(["MAN", this.GetString("ProxyLabel")]);
        result.push(["TUT", this.GetString("GuardianLabel")]);

        return result;
    }

    public GetRAMQTerminationTypes(): [string, string][] {
        return [
            ["01", "Déménagement de la personne assuréee"],
            ["02", "À la demande du professionnel"],
            ["03", "Départ volontaire de la personne assurrée"]
        ];
    }

    public GetPhoneContactPointTypeLookupTuples(): [FlatLookupView, FlatLookupView][] {
        let result: [FlatLookupView, FlatLookupView][] = [];

        let phonetypes = this.FindLookupsByTypeCode("PHONETYPE");
        let contactPointType = this.FindLookupsByTypeCode("CONTACTPOINTTYPE");

        contactPointType
            .forEach(x => {
                phonetypes.forEach(y => {
                    result.push([x, y]);
                });
            });

        return result;
    }

    public GetEmailContactPointTypeLookups(): FlatLookupView[] {
        return this.FindLookupsByTypeCode("CONTACTPOINTTYPE");
    }

    public GetClientIdentifier(): string {
        return this.ClientIdentifier;
    }

    public IsFamilyDoctor(): boolean {
        return true;
    }

    public GetSentFaxSentStatusName(faxStatus: EnumSentFaxStatus): string {
        switch (faxStatus) {
            case EnumSentFaxStatus.InProgress:
                return this.GetString("InProgressLabel");

            case EnumSentFaxStatus.Sent:
                return this.GetString("SentLabel");

            case EnumSentFaxStatus.Failed:
                return this.GetString("FailedLabel");

            case EnumSentFaxStatus.SendingEmail:
                return this.GetString("SendingEmailLabel");

            case EnumSentFaxStatus.NoAnswer:
                return this.GetString("NoAnswerLabel");

            case EnumSentFaxStatus.Busy:
                return this.GetString("BusyLabel");

            case EnumSentFaxStatus.NoRemoteFax:
                return this.GetString("NoRemoteFax");

            case EnumSentFaxStatus.NoRemoteFax:
                return this.GetString("NotSentLabel");

            default:
                return "";
        }
    }

    public getSentFaxUiStatusName(status: SentFaxUiStatus): string {
        switch (status) {
            case SentFaxUiStatus.InProgress:
                return this.GetString("InProgressLabel");

            case SentFaxUiStatus.Sent:
                return this.GetString("SentFaxInfoBox_SentStatusLabel");

            case SentFaxUiStatus.Failed:
                return this.GetString("FailedLabel");

            case SentFaxUiStatus.Error:
                return this.GetString("ErrorLabel");

            default:
                return "";
        }
    }

    public GetPhoneByType(phones: PhoneNumber[], phoneType: string, contactPointType: string, addUnions: boolean = false): string {
        return this.GetPhoneDetailsByType(phones, phoneType, contactPointType, addUnions)?.number;
    }
    public GetPhoneDetailsByType(phones: PhoneNumber[], phoneType: string, contactPointType: string, addUnions: boolean = false): { number: string, extension: string } {
        if (!phones) {
            return null;
        }
        {
            let results = phones.filter(x => this.FilterPhoneByTypes(x, phoneType, contactPointType));

            if (results?.length > 0) {
                let preferred = results.firstOrDefault(s => s.IsPreferred);

                let phoneToFormat = preferred?.Number ?? results[0]?.Number;

                if (phoneToFormat != null) {
                    phoneToFormat = this.FormatPhoneNumber(phoneToFormat, addUnions);
                }

                let extension = preferred?.Extension ?? results[0]?.Extension;
                return {
                    number: phoneToFormat,
                    extension: extension
                };
            }
            return null;
        }
    }

    private FilterPhoneByTypes(phone: PhoneNumber, phoneType: string, contactPointType: string): boolean {
        return PhoneUtils.FilterPhoneByTypes(phone, phoneType, contactPointType, this.GetLookupById.bind(this));
    }

    private FormatPhoneNumber(phoneNumber: string, addUnions: boolean): string {
        return PhoneUtils.FormatPhoneNumber(phoneNumber, addUnions);
    }

    public getCountryByLookupId(lookupId: string): GeographicInfoCountry {
        if (IsNullOrWhiteSpace(lookupId))
            return null;

        const countryLookup = this.GetCountryLookups().firstOrDefault(p => p.LookupID === lookupId);

        return countryLookup && this.getCountryMedfarDictionariesByLookUpCode(countryLookup.LookupCode);
    }

    public getStateByLookupId(lookupId: string): GeographicInfoState {
        if (IsNullOrWhiteSpace(lookupId))
            return null;

        const stateLookup = this.GetLookupById(lookupId);
        return this.getStateMedfarDictionariesByLookUpCode(stateLookup.LookupCode);
    }

    public getCountryMedfarDictionariesByLookUpCode(lookupCode: string): GeographicInfoCountry {
        if (IsNullOrWhiteSpace(lookupCode))
            return null;

        return this.CountryCache
            .firstOrDefault(x => x.Myle_LookupCode === lookupCode);
    }

    public getCountryMedfarDictionariesByISOCodeAlpha2(alpha2code: string): GeographicInfoCountry {
        if (!alpha2code)
            return null;

        alpha2code = alpha2code.toUpperCase().trim();
        const country = this.CountryCache.firstOrDefault(p => p.Alpha2Code == alpha2code);
        return country;
    }

    public GetCountryLookupCodeByISOCodeAlpha2(alpha2code: string): string | null {
        if (!alpha2code)
            return null;

        const country = this.getCountryMedfarDictionariesByISOCodeAlpha2(alpha2code);
        return country
            ? country.Myle_LookupCode
            : null;
    }

    public GetCountryLookupByISOCodeAlpha3(alpha3Code: string): string | null {
        if (!alpha3Code)
            return null;

        alpha3Code = alpha3Code.toUpperCase().trim();
        let country = this.CountryCache.firstOrDefault(x => x.Alpha3Code == alpha3Code);
        return country
            ? country.Myle_LookupCode
            : null;
    }

    public GetCountryLookupById_medfarDictionaries(id: string): string | null {
        if (!id)
            return null;

        let country = this.CountryCache.firstOrDefault(x => x.Id == id);
        return country
            ? country.Myle_LookupCode
            : null;
    }

    public GetMDFamille_LORSpecialityId(): string[] {
        if (this.memorizedMDFamille_LORSpecialityId == null) {
            this.memorizedMDFamille_LORSpecialityId = this.TitlesAndSpecialtiesCache
                .filter(specialty => EmployeeTitleHelper.isDoctor(specialty.Model.licenceOrganisationRuleModel.Title) && specialty.Model.licenceOrganisationSpecialisationModel.SpecialisationCode == "0")
                .toArray()
                .map(specialty => specialty.Model.licenceOrganisationSpecialisationModel.Id)
                .distinct();
        }

        return this.memorizedMDFamille_LORSpecialityId;
    }

    public GetMDFamilleResident_LORSpecialityId(): string[] {
        if (this.memorizedMDFamilleResident_LORSpecialityId == null) {
            this.memorizedMDFamilleResident_LORSpecialityId = this.TitlesAndSpecialtiesCache
                .filter(specialty => specialty.Model.licenceOrganisationRuleModel.Title === EmployeeTitle.Resident && specialty.Model.licenceOrganisationSpecialisationModel.SpecialisationCode == "0")
                .toArray()
                .map(specialty => specialty.Model.licenceOrganisationSpecialisationModel.Id)
                .distinct();
        }

        return this.memorizedMDFamilleResident_LORSpecialityId;
    }

    public GetPortalSubscriptionPlanInfo(subscriptionPlanId: string): SubscriptionPlanDto {
        return !IsNullOrWhiteSpace(subscriptionPlanId) && this.portalConfiguration?.HasSubscriptions && this.portalConfiguration?.SubscriptionPlans && this.portalConfiguration?.SubscriptionPlans.length
            ? this.portalConfiguration?.SubscriptionPlans.firstOrDefault(p => p.SubscriptionPlanId === subscriptionPlanId)
            : null;
    }

    public updateEmployeeCacheForVacation(vacationUpdateList: TempLightVacation[]): void {
        this.EmployeeCache = this.EmployeeCache
            .map(b => {
                for (let vacation of vacationUpdateList) {
                    if (b.ContactFacet_id === vacation.ContactFacet_id) {
                        b.IsInVacation = vacation.IsInVacation;
                        b.FromVacationDate = vacation.FromVacationDate;
                        b.ToVacationDate = vacation.ToVacationDate;
                        b.VacationNote = vacation.VacationNote;
                    }
                }
                return b;
            });
    }

    public GetCountryMedfarDictionariesByLookUpType(typeName: string): GeographicInfoCountry {
        if (!typeName)
            return null;

        typeName = typeName.toUpperCase().trim();
        return this.CountryCache.firstOrDefault(x => x.Myle_LookupCode == typeName);
    }

    public GetStateMedfarDictionariesByLookUpTypeCode(typeCode: string): GeographicInfoState[] {
        if (!typeCode)
            return null;

        typeCode = typeCode.trim();
        return this.StateCache.filter(x => x.Myle_LookupTypeCode == typeCode);
    }

    public getStateMedfarDictionariesByLookUpCode(lookupCode: string): GeographicInfoState {
        if (!lookupCode)
            return null;

        lookupCode = lookupCode.trim();
        return this.StateCache.firstOrDefault(x => x.Myle_LookupCode == lookupCode);
    }

    public GetStateMedfarDictionariesByLookUpType(typeName: string): GeographicInfoState {
        if (!typeName)
            return null;

        typeName = typeName.trim();
        return this.StateCache.firstOrDefault(x => x.Myle_LookupCode == typeName);
    }

    public GetStateMedfarDictionariesBySubdivisionCode(subCode: string): GeographicInfoState {
        if (!subCode)
            return null;

        subCode = subCode.trim();
        return this.StateCache.firstOrDefault(x => x.SubdivisionCode == subCode);
    }

    public GetStateMedfarDictionariesById_MedfarDic(id: string): GeographicInfoState {
        if (!id)
            return null;

        return this.StateCache.firstOrDefault(x => x.Id == id);
    }

    public GetPatientExternalSearchSystemCodesForActiveSite(): string[] {
        let activeSiteId = this.GetCurrentEmployee().ActiveSiteId;
        return this.ExternalSearchSystemsBySiteId?.[activeSiteId]?.map(p => p.Code) ?? [];
    }

    public IsApexInterfaceActive(): boolean {
        return this.IsChristus();
    }

    public IsRISInterfaceActive(): boolean {
        return this.IsChristus();
    }

    public IsChristus(): boolean {
        return this.ClientIdentifier.toLowerCase() == "christustest"
            || this.ClientIdentifier.toLowerCase() == "christus";
    }

    public RefreshEmployeeGroup(group: EmployeeGroup): void {
        if (!this.EmployeeGroupCache.some(x => x.Id == group.Id))
            this.EmployeeGroupCache.push(group);
        else {
            let allGroups = this.EmployeeGroupCache;
            let filterNewGroupList = allGroups.filter(x => x.Id != group.Id);
            filterNewGroupList.push(group);
            this.EmployeeGroupCache = filterNewGroupList;
        }
        this.refreshClinicianArrays();
    }

    public getPDFForms(then: (pdfFormList: RadPdfFormData[]) => void): void {
        if (this.PDFFormsList && this.PDFFormsList.length > 0)
            then(this.PDFFormsList);
        else
            this.getPDFFormsLink(then);
    }

    public updateFavoriteFormCache(genericForm: GenericForm): void {
        // add it
        if (genericForm.isFavorite) {
            if (!this.FavoriteForms.some(z => z.FormType == genericForm.formType && z.FormId == genericForm.formId)) {
                let newFavForm = new FavoriteForm();
                newFavForm.FormId = genericForm.formId;
                newFavForm.FormType = genericForm.formType;
                this.FavoriteForms.push(newFavForm);
            }
        }

        // remove it
        else
            this.FavoriteForms = this.FavoriteForms.filter(z => !(z.FormType == genericForm.formType && z.FormId == genericForm.formId));
    }

    public getTaskStatuses(): CheckboxUIModel[] {
        return this
            .FindLookupsByTypeCode("TaskStatus")
            .map(x => {
                const stat = new CheckboxUIModel();
                stat.Id = x.LookupID;
                stat.Target = CheckboxTarget.Myle_Communications_Messages_Search_Status;
                stat.Name = this.GetLocalizedValueByLookupId(x.LookupID);
                stat.Checked = true;
                return stat;
            });
    }

    public getQuestionnaireName(questionnaireId: string): string {
        if (!this.AvailableQuestionnaires?.length)
            return "";

        let questionnaire = this.AvailableQuestionnaires.firstOrDefault(x => x.QuestionnaireId === questionnaireId);
        return questionnaire.Names
            .firstOrDefault(item => item.Key.toLowerCase().indexOf(sessionStore.locale) > -1)
            ?.Value || "";
    }

    public getQuestionnaireShortName(questionnaireId: string): string {
        return this.AvailableQuestionnaires
            ?.firstOrDefault(x => x.QuestionnaireId === questionnaireId)
            ?.ShortName || "";
    }

    public hasPharmaNetAccess(): boolean {
        return this.ClinicSettings.EnablePharmaNet
            && sessionStore
                .getCurrentEmployee()
                .getActiveSite()
                .Model
                .Adresses.some(a => a.StateLookupId === cacheStore.FindLookupByLookupCode("CanadaState_BC").LookupID);
    }

    public hasInboundFaxPermission(): boolean {
        if (this.faxAccounts?.any())
            return this.faxAccounts.some(x => x.FaxNumbers?.some(y => y.CanReceive) || false) ?? false;

        return false;
    }

    public getConsentMotiveLookups(): FlatLookupView[] {
        return this
            .FindLookupsByTypeName("ConsentMotive")
            .sortByProperty(p => p.LookupPosition);
    }

    public getServiceProvidersName(employeeContactFacetIds: string[]): string {
        if (!isArrayNullOrUndefinedOrEmpty(employeeContactFacetIds)) {
            if (employeeContactFacetIds.length === 1) {
                const employee = this.GetCliniciansPersonsByContactFacetId(employeeContactFacetIds[0].toLowerCase());
                return employee.NameWithPrefix;
            }
            else {
                return `${employeeContactFacetIds.length} ${cacheStore.GetString("ResponsibleProvidersLabel")}`;
            }
        }

        return "";
    }

    public canSendFaxes(): boolean {
        return this.faxAccounts?.any();
    }

    public canReceiveFaxes(): boolean {
        return this.faxAccounts?.some(x => x.FaxNumbers?.some(y => y.CanReceive) || false) ?? false;
    }

    public getCountryAndStateLookups(): FlatLookupView[] {
        const countryLookups = this.GetCountryLookups();
        const stateLookups: FlatLookupView[] = [];
        for (const element of countryLookups) {
            const stateLookupsOfCountry = this.GetCountryRegionLookups(element);
            for (const lookup of stateLookupsOfCountry)
                stateLookups.push(lookup);
        }

        return countryLookups.concat(stateLookups);
    }

    public getFilteredOrganizationRulesParam(filter?: (organizationRule: LicenceOrganisationRule) => boolean): IFilteredOrganizationRulesParams {
        return ({
            allOrgRules: Object.values(this.AllLicenseOrganizationRulesById).filter(p => filter?.(p) ?? true),
            sitesAddress: this.SitesAddressCache,
            locationMapper: this.LocationMapper,
            countryCache: this.CountryCache.filter(p => !IsNullOrWhiteSpace(p.Myle_LookupCode) && !IsNullOrWhiteSpace(p.Myle_LookupTypeCode)),
            stateCache: this.StateCache.filter(p => !IsNullOrWhiteSpace(p.Myle_LookupCode) && !IsNullOrWhiteSpace(p.Myle_LookupTypeCode)),
            countryAndStateLookups: this.getCountryAndStateLookups()
        });
    }

    public GetGeographicCountriesByIsoCodes(isoCodes: string[]): GeographicInfoCountry[] {
        return this.CountryCache
            .filter(p => isoCodes.contains(p.Alpha2Code))
            .sortByProperty(p => p.Name);
    }

    public GetGeographicsStatesForCountryId(countryId: string): GeographicInfoState[] {
        return this.StateCache
            .filter(p => p.CountryId === countryId)
            .sortByProperty(p => p.Name);
    }

    public getDiscontinueReasonLookups(): FlatLookupView[] {
        return this
            .FindLookupsByTypeName(DiscontinueReason.Code)
            .sortByProperty(p => p.LookupPosition);
    }

    public validateMylePharmacy(isMylePharmacy: boolean): boolean {
        return cacheStore.ClinicSettings.EnableSendPrescriptionToMylePharmacy && isMylePharmacy;
    }

    public updateCurrentEmployeeMedicalNoteAllowlistCache(nextAllowlist: IAllowlistModel): void {
        this.GetCurrentEmployee().MedicalNoteAllowlist = nextAllowlist;
    }

    public setEmployeeTermsAndConditionsAgreement(newEmployeeAgreements: EmployeeTermsAndConditionsAgreement[]): void {
        this.employeeTermsAndConditionsAgreement = [...newEmployeeAgreements];
    }

    public getEmployeeTermsAndConditionsAgreement(): EmployeeTermsAndConditionsAgreement[] {
        return this.employeeTermsAndConditionsAgreement;
    }

    public async getSharedItemCategories(): Promise<SharedItemCategory[]> {
        if (this.sharedItemCategories?.length)
            return this.sharedItemCategories;

        const response = await Client.postAsync<SharedItemCategoryResponse>(
            ServerOperations.Server.Myle_PortalCommunication_GetSharedItemCategories,
            null
        );

        if (response.isSuccess) {
            this.sharedItemCategories = response.data.SharedItemCategories;
            return this.sharedItemCategories;
        }
    }

    private shouldShowCounts(topCount?: number, bottomCount?: number, counts?: ICounters): boolean {
        if (counts)
            return counts.showCounters();

        return !IsNullOrUndefined(topCount) || !IsNullOrUndefined(bottomCount);
    }

    private getTooltipList(key: MyleTabKey, tooltip?: MyleMenuTabTooltip): ICounters | null {
        switch (key) {
            case MyleTabKey.Communications:
                return tooltip?.communicationsCounters;
            case MyleTabKey.LabResults:
                return tooltip?.resultsCounters;
            case MyleTabKey.PrescriptionRenewals:
                return tooltip?.prescriptionRenewalsCounters;
            case MyleTabKey.Documents:
                return tooltip?.documentsCounters;
            case MyleTabKey.Portfolio:
                return tooltip?.portfolioCounters;
            default:
                return null;
        }
    }

    private GetLookupByLookupCode(lookupCode: string): FlatLookupView[] {
        if (IsNullOrWhiteSpace(lookupCode))
            return [];

        let listBylookupCode = this.LookupsByLookupCodeCacheDict[lookupCode];
        if (listBylookupCode == null) {
            listBylookupCode = this.Lookups.filter(l => l.LookupCode.toUpperCase() == lookupCode.toUpperCase());
            this.LookupsByLookupCodeCacheDict[lookupCode] = listBylookupCode;
        }
        else
            listBylookupCode = this.LookupsByLookupCodeCacheDict[lookupCode];

        return listBylookupCode || [];
    }

    private prepareEmployeeForCache(employee: Employee, serviceDefinitionModelCache: ServiceDefinitionModel[], addEmployeeToServiceDefinition: boolean = false): Employee {
        employee.PrefixLookup = employee.PrefixLookupId != null
            ? this.GetLookupById(employee.PrefixLookupId)
            : new FlatLookupView();

        employee.ServicesOffered = [];
        employee.ServicesIDsOffered
            .forEach(service => {
                service.EmployeeId = employee.ContactFacet_id;
                if (!service.IsInactive) { // only set active services in "ServicesOffered" array
                    let serviceDef = serviceDefinitionModelCache.firstOrDefault(x => x.Model.Id == service.DefId);
                    if (serviceDef) {
                        employee.ServicesOffered.push(new ServiceModel(service.Id, serviceDef.Clone(false)));

                        // Push EmployeeId To Service Def;
                        if (addEmployeeToServiceDefinition) {
                            let nameWithPrefix = (employee.PrefixLookup.GetValue() ? (employee.PrefixLookup.GetValue() + " ") : "") + employee.LastName + " " + employee.FirstName;

                            if (serviceDef.Employees && serviceDef.Employees.indexOfObject("ContactFacetId", employee.ContactFacet_id) == -1)
                                serviceDef.Employees.push(new ServiceDefinitionModelEmployee(employee.ContactFacet_id, nameWithPrefix));
                        }
                    }
                }
            });

        this.ServicesByEmployees[employee.ContactFacet_id] = employee.ServicesIDsOffered;

        if (employee.Licences != null && employee.Licences.length > 0) {
            employee.Licences = employee.Licences.map(p => new License(p));
            employee.FirstLicenceNumber = employee.Licences[0].LicenceNumber;
        }

        return employee;
    }

    private clearEmployeeFromServiceCache(employee: Employee, serviceDefinitionModelCache: ServiceDefinitionModel[]): void {
        serviceDefinitionModelCache
            .forEach(x => {
                let idx = x.Employees.indexOfObject("ContactFacetId", employee.ContactFacet_id);
                if (idx > -1)
                    x.Employees.splice(idx, 1);
            });
    }

    private refreshClinicianArrays(): void {
        this.Clinicians = this.GetClinicians(false);
        this.CliniciansWithInactive = this.GetClinicians(true);
        this.CliniciansAndEmployeeGroups = this.GetActiveCliniciansAndEmployeeGroups();
    }

    private getPDFFormsLink(then: (pdfFormList: RadPdfFormData[]) => void): void {
        const client = new Client();
        client.Post(
            apiSettings.buildApiPath(),
            ServerOperations.Server.Myle_Patient_MedicalNote_GetFormsList,
            {
                AllowTags: this.GetCurrentEmployee().AllowedFormTags.toString()
            },
            response => {
                const formsRaw = response?.PatientForms as RadPdfFormResponse[] ?? [];
                if (formsRaw && formsRaw.length > 0) {
                    this.PDFFormsList = RadPdfFormData.fromResponseModelArray(formsRaw);
                    then(this.PDFFormsList);
                }
            },
            error => console.error(error)
        );
    }

    private updateLockedTab(tab: MyleMenuTabItem, disableWaitTime?: boolean): void {
        // update lock
        tab.isLocked = tab.path.toLowerCase() == "patients"
            ? !sessionStore.selectedFile // locked if no opened files
            : tab.isLocked;

        // update cache
        if (this.timeoutReferenceCacheChange !== -1)
            clearTimeout(this.timeoutReferenceCacheChange);
        this.timeoutReferenceCacheChange = window.setTimeout(
            () => {
                if (this.cacheChangeTimeStamp == null || this.cacheChangeTimeStamp < DateTime.nowDeprecated().addSeconds(-5) || disableWaitTime) { // more than 5 seconds
                    this.cacheChangeTimeStamp = DateTime.nowDeprecated();
                    this.EmitChangeToListeners();
                }
            },
            20
        );
    }

    private BindCache(response: Cache): void {
        this.HasFRLookups = response.HasFRLookups;
        this.HasESLookups = response.HasESLookups;
        this.RADPdfFormEditUrl = response.RADPdfFormEditUrl;
        this.RADPdfFormViewUrl = response.RADPdfFormViewUrl;
        this.LookupsDict = {};
        this.LookupsByLookupCodeCacheDict = {};
        this.LookupsByTypeCodeCacheDict = {};
        this.LookupsByTypeNameCacheDict = {};
        this.SpecificClientSettings = response.SpecificClientSettings;
        this.RiskFactorCodeCache = response.RiskFactorCodeCache.toLookup(p => p.Category);
        this.RiskFactorCodeByIdCache = response.RiskFactorCodeCache.toDictionary(p => p.Id);
        this.BindLookups(response.LookupCache);

        this.EmployeeGroupCache = response.EmployeeGroupCache;

        this.ClinicSettings = new ClinicSettings(response.ClinicSettings);
        this.ClinicSettingsServices = response.ClinicSettingsServices;
        this.ClinicSettingsSingleSignOnProviders = response.ClinicSettingsSingleSignOnProviders;
        this.ClinicSettings_Portal = response.ClinicSettings_Portal;
        this.NotificationConfiguration = response.NotificationConfiguration;

        this.screeningTestProfiles = [];
        this.screeningTestDefinitions = [];
        this.screeningTestProfileDefinitions = [];

        // bind Safir service
        this.SafirApssURL = this.ClinicSettingsServices.SafirApss;

        this.ArlMyleDatabaseLocation = response.ArlMyleDatabaseLocation;

        this.CurrentUserDefaultSpecializationLookupId = response.LastSpecializationLookupId;

        this.BindEmployeesAndServices(response.ServiceDefinitionCache, response.EmployeeCache, response.ServiceDefinitionComboCache);
        this.SentForApprovalCliniciansId = response.SentForApprovalCliniciansId;
        this.DocumentSources = response.DocumentSources;
        this.UserSettings = response.UserSettings;
        this.ValidationRules = response.ValidationRules;
        this.MedfarDictionariesValidationRules = response.MedfarDictionariesValidationRules;
        this.InsuranceProviderCache = response.InsuranceProviderCache;
        this.ReligionCache = response.ReligionCache;
        this.UnitsCache = response.UnitsCache;
        this.RoutesCache = response.RoutesCache;
        this.VaccinesCache = response.VaccinesCache;
        this.FrequenciesCache = response.FrequenciesCache;
        this.FavoritePrescriptions = Immutable.List(PatientMedicalSummaryHelper.InitMedications(response.FavoritePrescriptions));
        this.FavoriteDiagnoses = Immutable.List(PatientMedicalSummaryHelper.InitDiagnoses(response.FavoriteDiagnoses));
        this.CountryCache = response.CountryCache;
        this.CountryCacheById = response.CountryCache.toDictionary(p => p.Id);
        this.StateCache = response.StateCache;
        this.StateCacheById = response.StateCache.toDictionary(p => p.Id);
        this.LocationMapper = new LocationMapper(response.CountryCache, response.StateCache, this.getCountryAndStateLookups());
        this.ClientIdentifier = response.ClientIdentifier;
        this.portalConfiguration = response.PortalConfiguration;
        this.DropDownOptions = response.DropDownOptions;
        this.DropDownOptionsByTypCacheDict = this.DropDownOptions.map(x => new DropDownOption(x)).toLookupDictionary(x => x.model.Type);

        this.defaultCanadaTaxes = response.DefaultCanadaTaxes;
        this.CanadianTriageAndAcuityScoreList = response.CanadianTriageAndAcuityScores;

        this.faxAccounts = response.FaxAccounts;

        this.screeningTestProfiles = response.ScreeningTestProfiles ? response.ScreeningTestProfiles : [];
        this.screeningTestDefinitions = response.ScreeningTestDefinitions ? response.ScreeningTestDefinitions.map(s => new ScreeningTestDefinition(s)) : [];
        this.screeningTestProfileDefinitions = response.ScreeningTestProfileDefinitions ? response.ScreeningTestProfileDefinitions : [];

        this.Permissions = response.Permissions;

        this.RegionsCache = response.RegionsCache;
        this.TownsCache = response.TownsCache;
        this.CostCenterCache = response.CostCenter;
        this.bindSites(response.SiteCache);

        this.ExternalSearchSystemsResponse = response.ExternalSearchSystems ?? [];
        this.ExternalSearchSystemSitesResponse = response.ExternalSearchSystemSites ?? [];

        const ExternalSearchSystemSitesResponseById = this.ExternalSearchSystemSitesResponse.toLookup(p => p.Id);

        const externalSystems = response.ExternalSearchSystems.map(p => new ExternalSearchSystem(p, ExternalSearchSystemSitesResponseById[p.Id]));

        // bySiteId Key Lookup
        this.ExternalSearchSystemsBySiteId = {};
        for (const p of this.ExternalSearchSystemSitesResponse) {
            this.ExternalSearchSystemsBySiteId[p.SiteId] = this.ExternalSearchSystemsBySiteId[p.SiteId] || [];

            this.ExternalSearchSystemsBySiteId[p.SiteId] = this.ExternalSearchSystemsBySiteId[p.SiteId]
                .concat(externalSystems.filter(system => system.Sites.any(s => s.SiteId == p.SiteId)));
        }

        this.PatientExternalIdentifierIndexes = response.PatientExternalIdentifierIndexes;
        this.PatientExternalIdentifierIndexesSites = response.PatientExternalIdentifierIndexesSites;
        this.PatientExternalIdentifierIndexesBySystemCode = response.PatientExternalIdentifierIndexes.toLookup(p => p.SystemCode);
        this.PatientExternalIdentifierIndexesSitesBySystemCode = response.PatientExternalIdentifierIndexesSites.toLookup(p => p.SystemCode);

        this.SitesAddressCache = response.SitesAddressCache;
        this.FavoriteForms = response.FavoriteForms;

        this.EmployeeSharingMessages = response.EmployeeSharingMessages || [];
        this.EmployeeSharingTasks = response.EmployeeSharingTasks || [];
        this.EmployeeSharingExternalCommunications = response.EmployeeSharingExternalCommunications || [];
        this.EmployeeSharingPortalCommunication = response.EmployeeSharingPortalCommunication || [];
        this.serviceTermsAndConditionsDictionary = response.ServiceTermsAndConditionsDictionary;
        this.BatchScanFileMaximum = response.BatchScanFileMaximum || 100000000;

        this.AvailableQuestionnaires = response.AvailableQuestionnaires?.map(x => new QuestionnaireName(x)) || [];

        this.AllLicenseOrganizationRulesById = response.OrganisationRulesNames?.toDictionary(p => p.Id) ?? {};
        this.CmqDoctorLicenseOrganizationRuleIds = response.OrganisationRulesNames.filter(p =>
            p.OrganisationCode === "CMQ"
            && p.CountryCode === "CA"
            && p.StateCode === "QC"
            && EmployeeTitleHelper.isDoctor(p.Title)
        ).map(p => p.Id);

        this.setEmployeeTermsAndConditionsAgreement(response.EmployeeTermsAndConditionsAgreement || []);
        if (sessionStore.getCurrentEmployee()?.isActiveSiteMexico())
            this.defaultCurrencyUnit = "MXN";

        if (cacheStore.ClinicSettings.EnableRecallList)
            this.PreventiveCareCriteriaList = response.PreventiveCareCriteriaList?.map(p => new PreventiveCareCriteria(p)) ?? [];
    }

    private async toggleFavorite(response: ToggleFavoriteResponse): Promise<void> {
        const {
            PrescriptionId: prescriptionIdAsResponse,
            IsRemove: isRemovedAsResponse,
            Success: isSucceededAsResponse,
            ReloadFavorites: shouldReloadFavorites
        } = response;

        if (!isSucceededAsResponse || !this.FavoritePrescriptions)
            return;

        const currentEmployeeContactFacetId: string = sessionStore.getCurrentEmployee().ContactFacetId;

        this.FavoritePrescriptions.forEach(p => {
            if (p.Model.EMRTemplatePrescriptionId === prescriptionIdAsResponse) {
                if (isRemovedAsResponse === true && p.Model.CreatorEmployeeId === currentEmployeeContactFacetId)
                    p.Model.CreatorEmployeeId = GuidHelper.Empty(); // Prepare to hide
                else
                    p.Model.CreatorEmployeeId = currentEmployeeContactFacetId;
            }
        });

        if (shouldReloadFavorites) {
            await this.requestReloadFavoritePrescription();
        }
    }

    private reloadFavoritePrescription(response: GetFavoritePrescriptionResponse): void {
        const favoritePrescription: MedicalItemMedicationAndPrescription[] = response?.MedicalItemMedicationAndPrescription ?? [];
        this.FavoritePrescriptions = Immutable.List(PatientMedicalSummaryHelper.InitMedications(favoritePrescription));
    }
}

export { CacheStore, defaultInstance as cacheStore };
